<div *ngIf="!showOemOesDiv" class="page-layout blank fullwidth" (scroll)="onScroll()" fusePerfectScrollbar style="height: 1px; overflow-y: scroll; margin-bottom: 5em;    top: 1px;    background: linear-gradient(45deg, #e2e8f8, #F8FAFF);" >
  <div class="page-wrapper" *ngIf="!showEmptyState">
    <!-- ===== HERO: 2-col grid (image left, info right) ===== -->
    <div class="product-hero">

      <!-- Left: Image Gallery -->
      <div class="product-gallery">
        <div class="main-image-wrapper">
          <div class="bdg-and-dscnt">
          <span class="badge-discount" *ngIf="selectedItem?.discount">
            {{ selectedItem?.discount }}% off
          </span>
            <!-- ✅ INDICATIVE IMAGE TAG -->
           <div
            class="indicative-tag-wrapper"
            *ngIf="isIndicativeImage(selectedImage || kitDefaultImage)"
            (mouseenter)="showIndicativeInfo()"
            (mouseleave)="hideIndicativeInfo()"
          >
            <span class="indicative-tag" (click)="toggleIndicativeInfo($event)">
              <span class="info-icon"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1_13)">
                <path d="M12.25 6.5C12.25 3.32436 9.67564 0.75 6.5 0.75C3.32436 0.75 0.75 3.32436 0.75 6.5C0.75 9.67564 3.32436 12.25 6.5 12.25C9.67564 12.25 12.25 9.67564 12.25 6.5Z" stroke="#144579" stroke-width="1.2"/>
                <path d="M6.5 5.5V9" stroke="#144579" stroke-width="1.2" stroke-linecap="round"/>
                <path d="M6.5 4.59999C6.83137 4.59999 7.1 4.33136 7.1 3.99999C7.1 3.66862 6.83137 3.39999 6.5 3.39999C6.16863 3.39999 5.9 3.66862 5.9 3.99999C5.9 4.33136 6.16863 4.59999 6.5 4.59999Z" fill="#144579"/>
                </g>
                <defs>
                <clipPath id="clip0_1_13">
                <rect width="13" height="13" fill="white"/>
                </clipPath>
                </defs>
                </svg>
              </span> Indicative Image
            </span>

            <!-- Popup anchored right under the tag -->
            <div class="indicative-popup" *ngIf="isIndicativeTagOpen">
              This is a representative image. Actual product may vary in appearance.
            </div>
          </div>
          </div>

          <span class="badge-sold"  *ngIf="selectedItem?.raw?.partInfo?.soldCount">
            {{ selectedItem?.raw?.partInfo?.soldCount || 0 }} Units Sold
          </span>
          <span class="badge-stock">
            ⏳ Limited stock at JC Road
          </span>    
          <!-- <img  [src]="selectedImage || kitDefaultImage" [alt]="selectedItem?.partName" class="main-image"  (error)="onImageError($event)"  /> -->
           <img
              [src]="selectedImage || kitDefaultImage"
              [alt]="selectedItem?.partName"
              class="main-image"
               (error)="onHeroImageError($event)"
            />
        </div>
        <!-- Thumbnail Strip -->
        <div class="thumbnail-strip" *ngIf="clutchList?.length > 1">
          <div 
            class="thumbnail-item"
            *ngFor="let item of filteredClutchList"
            [ngClass]="{ active: item.image === selectedImage }"
            (click)="selectImage(item)"
          >
            <img [src]="item.image || defaultImage"   (error)="onThumbnailImageError($event)" />
          </div>
        </div>
      </div>
      <!-- Right: Product Info 1st ui -->
       <div *ngIf="isSingleKit">
        <div class="product-info">
          <h1 class="product-title">
             {{ formatTitle(pricingSummary?.title) || 'Kit Product' }}
          </h1>

          <div class="rating-row">
            <!-- <span class="star">&#9733;</span>
            <span class="star">&#9733;</span>
            <span class="star">&#9733;</span>
            <span class="star">&#9733;</span>
            <span class="star">&#9733;</span> -->
            <span class="star" style="color: #000000;">⭐⭐⭐⭐⭐</span>
            <span class="rating-count">5 Ratings</span>
          </div>

          <div class="delivery-row">
            <svg class="truck-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
            </svg>
            <span class="delivery-text"> Dispatched in 15 Mins</span>
          </div>

          <div class="price-box">
            <div class="price-row">
                <span class="current-price">
                    ₹{{ selectedPricingSummary?.totalSellingPrice || 0 }}
                </span>

                <span class="original-price" *ngIf="selectedPricingSummary?.totalMrp">
                    ₹{{ selectedPricingSummary?.totalMrp }}
                </span>

                <div style="display: flex;    align-items: center;" *ngIf="selectedPricingSummary?.savings">
                  <img src="../../../../assets/images/productdetailsimage/save.png" style="margin: 10px;">
                  <span class="save-badge" >
                       Save ₹{{ selectedPricingSummary?.savings }}
                  </span>
              </div>

            </div>
            <p class="tax-note">Inclusive of all taxes</p>
          </div>
          <!-- TAGS ROW -->
          <!-- <div class="clutch-set-bran-main" >
            <div class="clutch-set-brand">
              <span>🏷️ Brand: </span><span class="clutch-set-brand-sub">{{ clutchList[0]?.brand }}</span>
            </div>
            <div class="clutch-set-brand">
              <span>🔩 Part: </span><span class="clutch-set-brand-sub" >{{ clutchList[0]?.partNumber }}</span>
            </div>
            <div class="clutch-set-brand">
              <span>🟢 Type:</span>
              <span class="clutch-set-brand-sub" >{{ clutchList[0]?.partType }}</span> 
            </div>
          </div> -->
          <div class="clutch-set-bran-main">
            <!-- Brand -->
            <div class="clutch-set-brand">
              <span>🏷️ Brand: </span>
              <span class="clutch-set-brand-sub">
                {{ brandText }}
              </span>
            </div>
            <!-- Part Numbers -->
            <div class="clutch-set-brand">
              <span>🔩 Part: </span>
              <span class="clutch-set-brand-sub">
                {{ partNumberText }}
              </span>
            </div>
            <!-- Types -->
            <div class="clutch-set-brand">
              <span>🟢 Type:</span>
              <span class="clutch-set-brand-sub">
                {{ partTypeText }}
              </span>
            </div>
          </div>
          <!-- WHAT YOU GET -->
          <p  class="wht-u-get">
            WHAT YOU GET IN THIS KIT
          </p>
          <!-- ITEMS LIST -->
          <div *ngFor="let item of clutchList"  class="parts-inld">
            <div class="prt-nms">

              <span *ngIf="item.partName?.toLowerCase().includes('disc')">
                💿
              </span>

              <span *ngIf="
                  !item.partName?.toLowerCase().includes('disc') &&
                  (
                    item.partName?.toLowerCase().includes('cover') ||
                    item.partName?.toLowerCase().includes('plate')
                  )
                ">
                🔧
              </span>

              <span *ngIf="
                  !item.partName?.toLowerCase().includes('disc') &&
                  !item.partName?.toLowerCase().includes('cover') &&
                  !item.partName?.toLowerCase().includes('plate') &&
                  item.partName?.toLowerCase().includes('bearing')
                ">
                ⚙️
              </span>

              <span
                *ngIf="
                  !item.partName?.toLowerCase().includes('disc') &&
                  !item.partName?.toLowerCase().includes('cover') &&
                  !item.partName?.toLowerCase().includes('plate') &&
                  !item.partName?.toLowerCase().includes('bearing') &&
                  (
                    item.partName?.toLowerCase().includes('flywheel') ||
                    item.partName?.toLowerCase().includes('fly wheel')
                  )
                "
                style="display: inline-flex; align-items: center; padding: 3px;"
              >
                <img
                  src="../../../../assets/images/clutch-flyingwheel.png"
                  class="part-icon"
                  style="width: 20px;"
                >
              </span>

              <span *ngIf="
                  !item.partName?.toLowerCase().includes('disc') &&
                  !item.partName?.toLowerCase().includes('cover') &&
                  !item.partName?.toLowerCase().includes('plate') &&
                  !item.partName?.toLowerCase().includes('bearing') &&
                  !item.partName?.toLowerCase().includes('flywheel') &&
                  !item.partName?.toLowerCase().includes('fly wheel')
                ">
                ⚙️
              </span>

              {{ item.partName }}

            </div>
            <div class="inld">
              Included
            </div>
          </div>
          <!-- <div style="background:#e8f5e9; padding:10px; border-radius:8px; text-align:center; font-weight:600; margin:10px 0;">
            ✅ All {{ clutchList.length }} parts included in this kit
          </div> -->
          <div class="sticky-cta" #stickyBtn>

            <!-- <div class="sticky-left">

              <div class="oess-selected-row">
                <span class="oess-save-pill" *ngIf="avxSelectedAddonCount > 0">
                  ✔ +{{ avxSelectedAddonCount }}
                  {{ avxSelectedAddonCount === 1 ? 'Part' : 'Parts' }} Added
                </span>
              </div>

              <div class="oess-info-box">
                <span class="oess-ordering-label">YOU ARE ORDERING</span>

                <div class="oess-kit-name">
                  {{ selectedItem?.partName || 'Clutch Set + Release Bearing' }}
                  <ng-container *ngIf="avxSelectedAddonCount > 0">
                    , {{ avxSelectedAddonNames }}
                  </ng-container>
                </div>
              </div>

            </div>

            <div class="sticky-right">

              <div class="oess-price-row">
                <div class="oess-price">
                  ₹{{ (pricingSummary?.totalSellingPrice || 0) + avxSelectedAddonAmount | number }}
                </div>

                <div class="oess-mrp">
                  ₹{{ (pricingSummary?.totalMrp || 0) + avxSelectedAddonMrp | number }}
                </div>
              </div>

              <button
                class="btn-add-cart"
                [ngClass]="{
                  'oem-btn-add-cart': selectedKitType === 'OEM',
                  'oes-btn-add-cart': selectedKitType === 'OES'
                }"
                (click)="onAddToCart()"
                #stickyBtn>
                ⚡
                {{
                  avxSelectedAddonCount > 0
                    ? ('Order ' + kitTitle + ' Package')
                    : ('Order Complete ' + selectedKitType + ' ' + kitTitle)
                }}
              </button>

              <div class="evrythng">
                Everything included. No extra parts needed.
              </div>

            </div> -->

            <div class="view-cart-partent-btn">
              <!-- BEFORE adding -->
              <button
                *ngIf="!kitInCart"
                class="btn-add-cart"
                [ngClass]="{
                  'oem-btn-add-cart': selectedKitType === 'OEM',
                  'oes-btn-add-cart': selectedKitType === 'OES'
                }"
                (click)="onAddToCart()">
                <mat-icon>shopping_cart</mat-icon> Add to Cart
              </button>

              <!-- AFTER adding -->
              <div *ngIf="kitInCart" class="qty-cart-row">
                <div class="btn-group">
                  <button class="button1" mat-raised-button (click)="decreaseKitQty()">
                    <mat-icon class="sidebuttons1">remove</mat-icon>
                  </button>
                  <input type="text" [value]="kitQty" readonly>
                  <button class="button1" mat-raised-button (click)="increaseKitQty()">
                    <mat-icon class="sidebutton1">add</mat-icon>
                  </button>
                </div>

                <button class="view-cart-btn" (click)="goToCart()"  [ngClass]="{
    'oem-view-cart-btn': selectedKitType === 'OEM',
    'oes-view-cart-btn': selectedKitType === 'OES'
  }">
                  <span class="vc-left">
                    <!-- <span class="vc-item-count">{{ kitQty }} Item{{ getKitQty() > 1 ? 's' : '' }}</span> -->
                    <span class="vc-item-count">{{ kitSummaryLabel }}</span>
                    <span class="vc-amount">₹ {{ kitTotalAmount  | number:'1.2-2' }}</span>
                  </span>
                  <span class="vc-right">View Cart</span>
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- END .product-info -->
      <!-- Right: Product Info 2nd ui -->
       <div class="right-container" *ngIf="isFullKit">
        <div class="scrollable-content" #productSection>
          <div class="product-info">
            <h1 class="product-title">
               {{ formatTitle(pricingSummary?.title) || 'Kit Product' }}
            </h1>

            <div class="rating-row">
              <!-- <span class="star">&#9733;</span>
              <span class="star">&#9733;</span>
              <span class="star">&#9733;</span>
              <span class="star">&#9733;</span>
              <span class="star">&#9733;</span> -->
              <span class="star" style="color: #000000;">⭐⭐⭐⭐⭐</span>
              <span class="rating-count">5 Ratings</span>
            </div>

            <div class="delivery-row">
              <svg class="truck-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
              </svg>
              <span class="delivery-text"> Dispatched in 15 Mins</span>
            </div>

            <div class="price-box">
              <div class="price-row">
                  <span class="current-price">
                     ₹{{ selectedPricingSummary?.totalSellingPrice || 0 }}
                  </span>

                  <span class="original-price" *ngIf="selectedPricingSummary?.totalMrp">
                      ₹{{ selectedPricingSummary?.totalMrp }}
                  </span>

                  <div style="display: flex;    align-items: center;" *ngIf="selectedPricingSummary?.savings">
                    <img src="../../../../assets/images/productdetailsimage/save.png" style="margin: 10px;">
                    <span class="save-badge" >
                        Save ₹{{ selectedPricingSummary?.savings }}
                    </span>
                </div>

              </div>
              <p class="tax-note">Inclusive of all taxes</p>
            </div>
            
            <!-- WHAT YOU GET -->
            <p  class="wht-u-get">
              WHAT YOU GET IN THIS KIT
            </p>
            <!-- <div class="split-row-parent">
                <div class="split-row">
                <div class="row-top">
                    <div class="left">
                    <div class="icons">
                        <div class="icon bg-yellow">💿</div>
                        <div class="icon bg-blue">⚙️</div>
                    </div>
                    <div class="info">
                        <div class="top-line">
                          <h4>{{ clutchList[0]?.partName }}</h4>
                          <span 
                            class="type-tag"
                            [ngClass]="clutchList[0]?.partType === 'OEM' ? 'oem-tag' : 'oes-tag'"
                          >
                            {{ clutchList[0]?.partType }}
                          </span>
                        </div>
                          <span class="sub-include">Includes {{ clutchList[0]?.partName || 'Includes parts' }}</span>
                          <span class="sub">🏭<span class="label">Brand:</span>  <span class="value">{{ clutchList[0]?.brand || '-' }}</span></span>
                          <span class="sub">🔢 <span class="label">Part Number:</span> <span class="value">{{ clutchList[0]?.partNumber || clutchList[0]?.partNo || '-' }}</span></span>

                        <div class="right">
                            <span class="price-val">₹{{ clutchList[0]?.sellingPrice || 0 }}<span class="mrp">₹{{ clutchList[0]?.mrp || 0 }}</span></span>
                            <span class="price-tag">Clutch Set price</span>
                        </div>
                        <div class="badge">✔ Pre-assembled set</div>
                    </div>
                    </div>
                </div>
                </div>
                <div class="split-row" *ngIf="clutchList.length > 1">
                <div class="row-top" style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px;">
                    <div class="left"  style="display: flex; gap: 10px; flex: 1; min-width: 0;">
                    <div class="icon bg-gray">🔩</div>
                    <div style="width: 100%; gap: 10px;">
                        <div class="info" style="flex: 1; min-width: 0;">
                            <div class="top-line" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <h4>{{ clutchList[1]?.partName || 'Part 2' }}</h4>
                            <span 
                              class="type-tag"
                              [ngClass]="clutchList[1]?.partType === 'OEM' ? 'oem-tag' : 'oes-tag'"
                            >
                              {{ clutchList[1]?.partType }}
                            </span>
                          </div>
                          <span class="sub">🏭<span class="label">Brand:</span>  <span class="value">{{ clutchList[1]?.brand || '-' }}</span></span>
                          <span class="sub">🔢 <span class="label">Part Number:</span> <span class="value">{{ clutchList[1]?.partNumber || clutchList[1]?.partNo || '-' }}</span></span>
                        </div>
                        <div class="right">
                            <span class="price-val">₹{{ clutchList[1]?.sellingPrice || 0 }}<span class="mrp">₹{{ clutchList[1]?.mrp || 0 }}</span></span>
                            <span class="price-tag"> {{ clutchList[1]?.partName || 'Part' }} price</span>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div> -->
            <div class="split-row-parent">
              <div class="split-row-top" *ngFor="let item of clutchList">

                <div class="row-top" style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px;">

                  <div class="left" style="display: flex; gap: 10px; flex: 1; min-width: 0;">
                    <!-- ICON -->
                    <!-- Clutch Set -->
                    <div
                      class="icons"
                      *ngIf="item.partName?.toLowerCase().includes('clutch set')"
                    >
                      <div class="icon bg-yellow">💿</div>
                      <div class="icon bg-blue">⚙️</div>
                    </div>
                    <!-- Disc -->
                    <div
                      class="icon bg-yellow"
                      *ngIf="
                        !item.partName?.toLowerCase().includes('clutch set') &&
                        item.partName?.toLowerCase().includes('disc')
                      "
                    >
                      💿
                    </div>
                    <!-- Cover / Plate -->
                    <div
                      class="icon bg-gray"
                      *ngIf="
                        !item.partName?.toLowerCase().includes('clutch set') &&
                        !item.partName?.toLowerCase().includes('disc') &&
                        (
                          item.partName?.toLowerCase().includes('cover') ||
                          item.partName?.toLowerCase().includes('plate')
                        )
                      "
                    >
                      🔩
                    </div>
                    <!-- Bearing -->
                    <div
                      class="icon bg-blue"
                      *ngIf="
                        !item.partName?.toLowerCase().includes('clutch set') &&
                        !item.partName?.toLowerCase().includes('disc') &&
                        !item.partName?.toLowerCase().includes('cover') &&
                        !item.partName?.toLowerCase().includes('plate') &&
                        item.partName?.toLowerCase().includes('bearing')
                      "
                    >
                      🔩
                    </div>
                    <!-- Default -->
                    <div
                      class="icon bg-blue"
                      *ngIf="
                        !item.partName?.toLowerCase().includes('clutch set') &&
                        !item.partName?.toLowerCase().includes('disc') &&
                        !item.partName?.toLowerCase().includes('cover') &&
                        !item.partName?.toLowerCase().includes('plate') &&
                        !item.partName?.toLowerCase().includes('bearing')
                      "
                    >
                      🔩
                    </div>
                    <div style="width: 100%; gap: 10px;">

                      <div class="info" style="flex: 1; min-width: 0;">

                        <div class="top-line" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">

                          <h4>{{ item?.partName || 'Part' }}</h4>

                          <span
                            class="type-tag"
                            [ngClass]="item?.partType === 'OEM' ? 'oem-tag' : 'oes-tag'"
                          >
                            {{ item?.partType }}
                          </span>

                        </div>

                        <span class="sub">
                          🏭<span class="label">Brand:</span>
                          <span class="value">{{ item?.brand || '-' }}</span>
                        </span>

                        <span class="sub">
                          🔢 <span class="label">Part Number:</span>
                          <span class="value">{{ item?.partNumber || item?.partNo || '-' }}</span>
                        </span>

                      </div>

                      <div class="right">

                        <span class="price-val">
                          ₹{{ (item?.sellingPrice || 0).toFixed(2)}}

                          <span class="mrp" *ngIf="item?.mrp" style="text-decoration: line-through;">
                            ₹{{ (item?.mrp).toFixed(2) }}
                          </span>
                          
                        </span>

                        <!-- <span class="price-tag">
                          {{ item?.partName || 'Part' }} price
                        </span> -->

                      </div>

                    </div>

                  </div>

                </div>

              </div>
            </div>
          </div>
         <div class="sticky-cta" #stickyBtn>

            <!-- <div class="sticky-left">

            <div class="oess-selected-row">

              <span class="oess-save-pill" *ngIf="avxSelectedAddonCount > 0">
                ✔ +{{ avxSelectedAddonCount }}
                {{ avxSelectedAddonCount === 1 ? 'Part' : 'Parts' }} Added
              </span>
            </div>

            <div class="oess-info-box">
              <span class="oess-ordering-label">YOU ARE ORDERING</span>

              <div class="oess-kit-name">
                {{ selectedItem?.partName || 'Clutch Set + Release Bearing' }}
                <ng-container *ngIf="avxSelectedAddonCount > 0">
                  , {{ avxSelectedAddonNames }}
                </ng-container>
              </div>
            </div>

          </div>

          <div class="sticky-right">

            <div class="oess-price-row">
              <div class="oess-price">
                ₹{{ (pricingSummary?.totalSellingPrice || 0) + avxSelectedAddonAmount | number }}
              </div>

              <div class="oess-mrp">
                ₹{{ (pricingSummary?.totalMrp || 0) + avxSelectedAddonMrp | number }}
              </div>
            </div>

            <button
              class="btn-add-cart"
              [ngClass]="{
                'oem-btn-add-cart': selectedKitType === 'OEM',
                'oes-btn-add-cart': selectedKitType === 'OES'
              }"
              (click)="onAddToCart()"
              #stickyBtn>
              ⚡
              {{
                avxSelectedAddonCount > 0
                  ? ('Order ' + kitTitle + ' Package')
                  : ('Order Complete ' + selectedKitType + ' ' + kitTitle)
              }}
            </button>

            <div class="evrythng">
                Everything included. No extra parts needed.
            </div>

          </div> -->
            <div #stickyBtn class="view-cart-partent-btn">
              <!-- BEFORE adding -->
              <button
                *ngIf="!kitInCart"
                class="btn-add-cart"
                [ngClass]="{
                  'oem-btn-add-cart': selectedKitType === 'OEM',
                  'oes-btn-add-cart': selectedKitType === 'OES'
                }"
                (click)="onAddToCart()">
                <mat-icon>shopping_cart</mat-icon> Add to Cart
              </button>

              <!-- AFTER adding -->
              <div *ngIf="kitInCart" class="qty-cart-row">
                <div class="btn-group">
                  <button class="button1" mat-raised-button (click)="decreaseKitQty()">
                    <mat-icon class="sidebuttons1">remove</mat-icon>
                  </button>
                  <input type="text" [value]="kitQty" readonly>
                  <button class="button1" mat-raised-button (click)="increaseKitQty()">
                    <mat-icon class="sidebutton1">add</mat-icon>
                  </button>
                </div>

                <button class="view-cart-btn" (click)="goToCart()"  [ngClass]="{
    'oem-view-cart-btn': selectedKitType === 'OEM',
    'oes-view-cart-btn': selectedKitType === 'OES'
  }">
                  <span class="vc-left">
                    <!-- <span class="vc-item-count">{{ kitQty }} Item{{ getKitQty() > 1 ? 's' : '' }}</span> -->
                    <span class="vc-item-count">{{ kitSummaryLabel }}</span>
                    <span class="vc-amount">₹ {{ kitTotalAmount  | number:'1.2-2' }}</span>
                  </span>
                  <span class="vc-right">View Cart</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
        <!-- <button  class="floating-cta"   [ngClass]="{    'oem-floating-cta': selectedKitType === 'OEM',    'oes-floating-cta': selectedKitType === 'OES'  }"  *ngIf="showFloatingBtn"    (click)="onAddToCart()">  {{  avxSelectedAddonCount > 0  ? ('Order ' + kitTitle + ' Package')     : ('Order Complete ' + selectedKitType + ' ' + kitTitle) }}  </button> -->
      <button
        class="floating-cta"
        [ngClass]="{
          'oem-floating-cta': selectedKitType === 'OEM',
          'oes-floating-cta': selectedKitType === 'OES'
        }"
        *ngIf="showFloatingBtn"
        (click)="onFloatingCtaClick()">

        <ng-container *ngIf="!kitInCart">
          <mat-icon>shopping_cart</mat-icon>
          Add {{ selectedKitType }} {{ kitTitle }}
        </ng-container>

        <ng-container *ngIf="kitInCart">
          ₹{{ kitTotalAmount | number:'1.0-0' }} · View Cart
        </ng-container>

      </button>
       <!-- END .product-info -->
    </div>
    <!-- END .product-hero -->
    <!-- ===== CLUTCH KIT UI SWITCH ===== -->
      <div class="kit-wrapper">

      <!-- ══════════════════════════════════════════
          SPLIT UI — 2 variables (!isFullKit)
      ══════════════════════════════════════════ -->
      <div *ngIf="isFullKit" class="kit-card split">
          <!-- <div class="included-bar"> ✅ Complete kit ( {{ selectedItem?.partName }} <span *ngIf="clutchList.length > 1">   + {{ clutchList[1]?.partName }} </span> included)</div> -->
          <!-- <div class="included-bar">✅ Complete kit (
            <ng-container *ngFor="let item of clutchList; let last = last; let i = index">
              
              {{ item?.partName }}
              
              <span *ngIf="!last">  
                +
              </span>

            </ng-container>
            included)
          </div> -->
          <div class="included-bar">✅ Complete kit (
            <ng-container *ngFor="let name of getUniquePartNames(); let last = last">
              {{ name }}
              <span *ngIf="!last"> + </span>
            </ng-container>
            included)
          </div>

          <!-- PRICE BREAKDOWN BOX -->
          <div class="price-breakdown">
          <p class="pb-label">PRICE BREAKDOWN</p>
          <div class="pb-divider"></div>
          <!-- <div class="pb-row" *ngFor="let item of clutchList">
              <span class="pb-name">{{ item?.partName }}</span>
              <span class="pb-val">₹{{ item?.sellingPrice || 0 }}<span class="mrp">₹{{ clutchList[1]?.mrp || 0 }}</span></span>
          </div> -->
          <div class="pb-row" *ngFor="let item of clutchList">
            <span class="pb-name">{{ item?.partName }}</span>
            <span class="pb-val">
              ₹{{(item?.sellingPrice || 0).toFixed(2) }}
              <span class="mrp" *ngIf="item?.mrp" style="text-decoration: line-through;">
                ₹{{ item?.mrp | number:'1.0-0' }}
              </span>
            </span>
          </div>
          <div class="pb-divider"></div>
          <div class="pb-total">
            <h3>
               ₹{{ selectedPricingSummary?.totalSellingPrice || 0 }}
              <span class="mrp"  *ngIf="selectedPricingSummary?.totalMrp" style="text-decoration: line-through;">
                 ₹{{ selectedPricingSummary?.totalMrp }}
              </span>
              <div style="display: flex;    align-items: center;" *ngIf="selectedPricingSummary?.savings">
                  <img src="../../../../assets/images/productdetailsimage/save.png" style="margin: 10px;">
                  <span class="save-badge" style=" color: #D4AF37; " >
                      Save ₹{{ selectedPricingSummary?.savings }}
                  </span>
              </div>
            </h3>
            <span>Final price • Full kit</span>
          </div>
          </div>
          <div class="pit-share-quote-container">
            <div class="pit-share-quote-title">
              QUOTE SUMMARY
            </div>
            <div class="pit-share-quote-card" (click)="shareOnWhatsApp()">
              <div class="pit-share-quote-left">
                <div class="pit-share-quote-icon">
                  <img src="../../../../assets/images/whats-app-icon/whats-app-icon-image.png" alt="whatsapp">
                </div>
                <div class="pit-share-quote-content">
                  <div class="pit-share-quote-heading">
                    Share Quote on WhatsApp
                  </div>
                  <div class="pit-share-quote-subtext">
                    Send this quote instantly on WhatsApp.
                  </div>
                  <div class="pit-share-quote-note">
                    Includes live quote link
                  </div>
                </div>
              </div>
              <button class="pit-share-quote-btn">
                <img src="../../../../assets/images/whats-app-icon/whats-app-icon-image.png" alt="whatsapp">
                <span>Share Quote</span>
              </button>
            </div>
            <div class="pit-share-quote-footer">
              The link will open in WhatsApp with the quote pre-filled.
            </div>
          </div>
          <!-- DELIVERY — row -->
          <p class="section-title top-gap">DELIVERY TIMELINE</p>
          <div class="delivery-row">
            <div class="delivery-card blue" *ngIf="avxSelectedAddonCount === 0">
                <div class="d-icon">⏱️</div>
                <p>Ready in 15 mins</p>
                <span>Dispatch time</span>
            </div>
            <div class="delivery-card green" *ngIf="avxSelectedAddonCount === 0">
                <div class="d-icon">🚚</div>
                <p>Free Shipping</p>
                <span>To your location</span>
            </div>
          </div>

          <div class="benefits">
          <div>🛡️ Warranty Certificate Included</div>
          <div>✅ 100% Genuine Parts</div>
          </div>

          <div class="stock-warning">⚡ Limited stock at JC Road</div>
          <!-- ========================================clutch-addon-section================= -->
          <div class="avx-clutch-addon-section" *ngIf="avxAddonParts?.length > 0">

            <div class="avx-clutch-addon-header">
              <div class="avx-clutch-addon-header-left">
                <div>
                  <div class="avx-clutch-addon-title">Add Other  {{ kitTitle }} Related Parts <span class="avx-clutch-addon-badge">Optional</span></div>
                  <div class="avx-clutch-addon-description">Add additional  {{ kitTitle }} related parts if needed. Users can independently choose OEM or OES for each part.</div>
                </div>
              </div>

              <label class="avx-select-all">
                <input type="checkbox" [(ngModel)]="avxAddonSelectAll" (change)="avxToggleSelectAllAddons()">
                <span>Select All</span>
              </label>
            </div>

            <div class="avx-cards-wrapper">

              <button class="avx-scroll-btn avx-scroll-left" (click)="!isAtStart && avxScrollAddonCards('left')" [disabled]="isAtStart">
                <mat-icon>chevron_left</mat-icon>
              </button>

              <div class="avx-clutch-addon-cards"  (scroll)="onAddonCardsScroll()" [class.avx-addon-center]="avxAddonParts?.length < 4" #avxAddonCards>
                <div class="avx-clutch-addon-card" *ngFor="let part of avxAddonParts"
                  [ngClass]="[part.colorClass,part.selected ? 'avx-clutch-addon-selected' : '']">

                  <div class="avx-clutch-addon-top">
                    <div class="avx-card-radio" (click)="avxToggleAddonSelection(part)">
                      <mat-icon *ngIf="part.selected">check</mat-icon>
                    </div>
                    <span class="avx-card-discount" *ngIf="part?.discount > 0">
                       🏷️ {{ part.discount }}% OFF
                    </span>
                    <div class="avx-card-code">
                      <img
                         [src]="part.productImageUrl ? part.productImageUrl : defaultImage"
                        [alt]="part.partName"  (error)="onImageError($event)"
                      />
                    </div>
                  </div>

                  <div class="avx-clutch-addon-body">

                    <div class="avx-part-title">{{part.partName }}</div>

                    <div class="avx-part-info"><div class="avx-part-label">🏭 Brand:</div><div class="avx-part-value">{{part.brand}}</div></div>
                    <div class="avx-part-info"><div class="avx-part-label">🔩 Part No:</div><div class="avx-part-value">{{part.partNumber}}</div></div>

                    <div class="avx-option-toggle"  [class.avx-toggle-disabled]="!hasBothOptions(part)">
                      <button type="button" class="avx-toggle-btn" [class.avx-oes-active]="part.selectedOption==='OES'"  [disabled]="!hasBothOptions(part)" (click)="avxSwitchAddonOption(part,'OES')">OES</button>
                      <button type="button" class="avx-toggle-btn" [class.avx-oem-active]="part.selectedOption==='OEM'"  [disabled]="!hasBothOptions(part)" (click)="avxSwitchAddonOption(part,'OEM')">OEM</button>
                    </div>

                    <div class="avx-price-row">
                      <div class="avx-selling-price">₹{{part.sellingPrice | number:'1.0-2'}}</div>
                      <div class="avx-mrp">₹{{part.mrp | number:'1.0-2'}}</div>
                    </div>

                    <div class="avx-save-line" *ngIf="part.saveAmount>0">💰 Save ₹{{part.saveAmount | number:'1.0-2'}} vs MRP</div>

                    <div class="avx-compare-box" [ngClass]="{   'avx-compare-oem': part.selectedOption === 'OEM',   'avx-compare-oes': part.selectedOption === 'OES'    }"  *ngIf="part.compareSave > 0">
                      <div class="avx-compare-title">
                        <ng-container *ngIf="part.selectedOption === 'OEM'; else oesText">
                         ⚖️ OES could save ₹{{ part.compareSave | number:'1.2-2' }}
                        </ng-container>

                        <ng-template #oesText>
                         💸 Save ₹{{ part.compareSave | number:'1.2-2' }} vs OEM
                        </ng-template>
                      </div>

                      <div class="avx-compare-subtitle">Better value • same fitment</div>
                    </div>

                    <button type="button" class="avx-kit-btn" [class.avx-kit-added]="part.selected" (click)="avxToggleAddonSelection(part)">
                      <mat-icon class="avx-kit-icon">
                        {{ part.selected ? 'check' : 'add_circle_outline' }}
                      </mat-icon>
                      {{part.selected ? 'Added to Kit' : 'Add to Kit'}}
                    </button>

                  </div>
                </div>

              </div>

              <button class="avx-scroll-btn avx-scroll-right" (click)="!isAtEnd && avxScrollAddonCards('right')"  [disabled]="isAtEnd">
                <mat-icon>chevron_right</mat-icon>
              </button>

            </div>

            <div class="avx-summary-section"  *ngIf="avxSelectedAddonCount > 0">
              <div>
                <div class="avx-summary-label">Parts Added to Kit</div>
                <div class="avx-summary-value">{{avxSelectedAddonCount}} Parts • ₹{{avxSelectedAddonAmount | number}}</div>
              </div>

              <div class="avx-summary-right">
                <div class="avx-summary-label">Total Savings</div>
                <div class="avx-summary-saving">₹{{avxSelectedAddonSavings | number}}</div>
              </div>
            </div>
            <div class="avx-price-note">
              <mat-icon>info</mat-icon>
              Prices are inclusive of taxes. Final pricing updates instantly based on selected parts and OEM/OES selection.
            </div>
          </div>
      </div>

      <!-- ══════════════════════════════════════════
          FULL KIT UI — 1 variable (isFullKit)
      ══════════════════════════════════════════ -->
      <div class="pit-share-quote-container" *ngIf="isSingleKit">
            <div class="pit-share-quote-title">
              QUOTE SUMMARY
            </div>
            <div class="pit-share-quote-card" (click)="shareOnWhatsApp()">
              <div class="pit-share-quote-left">
                <div class="pit-share-quote-icon">
                  <img src="../../../../assets/images/whats-app-icon/whats-app-icon-image.png" alt="whatsapp">
                </div>
                <div class="pit-share-quote-content">
                  <div class="pit-share-quote-heading">
                     Share Quote on WhatsApp
                  </div>
                  <div class="pit-share-quote-subtext">
                    Send this quote instantly on WhatsApp.
                  </div>
                  <div class="pit-share-quote-note">
                    Includes live quote link
                  </div>
                </div>
              </div>
              <button class="pit-share-quote-btn">
                <img src="../../../../assets/images/whats-app-icon/whats-app-icon-image.png" alt="whatsapp">
                <span>Share Comparison</span>
              </button>
            </div>
            <div class="pit-share-quote-footer">
              The link will open in WhatsApp with the quote pre-filled.
            </div>
      </div>
      <div *ngIf="isSingleKit" class="kit-card full">
          <p class="section-title top-gap">DELIVERY TIMELINE</p>
          <div class="delivery-row">
          <div class="delivery-card blue" *ngIf="avxSelectedAddonCount === 0">
              <div class="d-icon">⏱️</div>
              <p>Ready in 15 mins</p>
              <span>Dispatch time</span>
          </div>
          <div class="delivery-card green" *ngIf="avxSelectedAddonCount === 0">
              <div class="d-icon">🚚</div>
              <p>Free Shipping</p>
              <span>To your location</span>
          </div>
          </div>

          <div class="benefits">
          <div>🛡️ Warranty Certificate Included</div>
          <div>✅ 100% Genuine Parts</div>
          </div>

          <div class="stock-warning">⚡ Limited stock at JC Road</div>

      </div>
       <!-- ========================================clutch-addon-section================= -->
         <div *ngIf="isSingleKit && avxAddonParts?.length > 0" class="avx-clutch-addon-section">

          <div class="avx-clutch-addon-header">
            <div class="avx-clutch-addon-header-left">
              <div>
                <div class="avx-clutch-addon-title">Add Other  {{ kitTitle }} Related Parts <span class="avx-clutch-addon-badge">Optional</span></div>
                <div class="avx-clutch-addon-description">Add additional  {{ kitTitle }} related parts if needed. Users can independently choose OEM or OES for each part.</div>
              </div>
            </div>

            <label class="avx-select-all">
              <input type="checkbox" [(ngModel)]="avxAddonSelectAll" (change)="avxToggleSelectAllAddons()">
              <span>Select All</span>
            </label>
          </div>

          <div class="avx-cards-wrapper">

            <button class="avx-scroll-btn avx-scroll-left"  (click)="!isAtStart && avxScrollAddonCards('left')"  [disabled]="isAtStart">
              <mat-icon>chevron_left</mat-icon>
            </button>

            <div class="avx-clutch-addon-cards"  (scroll)="onAddonCardsScroll()" [class.avx-addon-center]="avxAddonParts?.length < 4" #avxAddonCards>

              <div class="avx-clutch-addon-card" *ngFor="let part of avxAddonParts"
                [ngClass]="[part.colorClass,part.selected ? 'avx-clutch-addon-selected' : '']">

                <div class="avx-clutch-addon-top">
                  <div class="avx-card-radio" (click)="avxToggleAddonSelection(part)">
                    <mat-icon *ngIf="part.selected">check</mat-icon>
                  </div>
                  <span class="avx-card-discount" *ngIf="part?.discount > 0">
                   🏷️ {{ part.discount }}% OFF
                  </span>
                  <!-- <div class="avx-card-code">{{part.code}}</div> -->
                   <div class="avx-card-code">
                      <img
                         [src]="part.productImageUrl ? part.productImageUrl : defaultImage"
                        [alt]="part.partName"  (error)="onImageError($event)"
                      />
                    </div>
                </div>
              
                <div class="avx-clutch-addon-body">

                  <div class="avx-part-title">{{part.partName }}</div>

                  <div class="avx-part-info"><div class="avx-part-label">🏭 Brand: </div><div class="avx-part-value">{{part.brand}}</div></div>
                  <div class="avx-part-info"><div class="avx-part-label">🔩 Part No: </div><div class="avx-part-value">{{part.partNumber}}</div></div>

                  <div class="avx-option-toggle" [class.avx-toggle-disabled]="!hasBothOptions(part)">
                    <button type="button" class="avx-toggle-btn" [class.avx-oes-active]="part.selectedOption==='OES'"  [disabled]="!hasBothOptions(part)" (click)="avxSwitchAddonOption(part,'OES')">OES</button>
                    <button type="button" class="avx-toggle-btn" [class.avx-oem-active]="part.selectedOption==='OEM'"  [disabled]="!hasBothOptions(part)" (click)="avxSwitchAddonOption(part,'OEM')">OEM</button>
                  </div>

                  <div class="avx-price-row">
                    <div class="avx-selling-price">₹{{part.sellingPrice | number:'1.0-2'}}</div>
                    <div class="avx-mrp">₹{{part.mrp | number:'1.0-2'}}</div>
                  </div>

                  <div class="avx-save-line" *ngIf="part.saveAmount>0">💰 Save ₹{{part.saveAmount | number:'1.0-2'}} vs MRP</div>

                  <div class="avx-compare-box" [ngClass]="{   'avx-compare-oem': part.selectedOption === 'OEM',   'avx-compare-oes': part.selectedOption === 'OES'    }"  *ngIf="part.compareSave > 0">
                    <div class="avx-compare-title">
                      <ng-container *ngIf="part.selectedOption === 'OEM'; else oesText">
                       ⚖️ OES could save ₹{{ part.compareSave | number:'1.2-2' }}
                      </ng-container>

                      <ng-template #oesText>
                        💸 Save ₹{{ part.compareSave | number:'1.2-2' }} vs OEM
                      </ng-template>
                    </div>

                    <div class="avx-compare-subtitle">Better value • same fitment</div>
                  </div>

                  <button type="button" class="avx-kit-btn" [class.avx-kit-added]="part.selected" (click)="avxToggleAddonSelection(part)">
                    <mat-icon class="avx-kit-icon">
                      {{ part.selected ? 'check' : 'add_circle_outline' }}
                    </mat-icon>
                    {{part.selected ? 'Added to Kit' : 'Add to Kit'}}
                  </button>

                </div>
              </div>

            </div>

            <button class="avx-scroll-btn avx-scroll-right" (click)="!isAtEnd && avxScrollAddonCards('right')" [disabled]="isAtEnd">
              <mat-icon>chevron_right</mat-icon>
            </button>

          </div>

          <div class="avx-summary-section"  *ngIf="avxSelectedAddonCount > 0">
            <div>
              <div class="avx-summary-label">Parts Added to Kit</div>
              <div class="avx-summary-value">{{avxSelectedAddonCount}} Parts • ₹{{avxSelectedAddonAmount | number}}</div>
            </div>

            <div class="avx-summary-right">
              <div class="avx-summary-label">Total Savings</div>
              <div class="avx-summary-saving">₹{{avxSelectedAddonSavings | number}}</div>
            </div>
          </div>
          <div class="avx-price-note">
            <mat-icon>info</mat-icon>
            Prices are inclusive of taxes. Final pricing updates instantly based on selected parts and OEM/OES selection.
          </div>
        </div>
      </div>

    <!-- ===== PRODUCT SPECIFICATIONS — full width, outside grid ===== -->
    <div class="specs-section">
      <h2 class="specs-heading">Product Specifications</h2>

      <div class="specs-grid">
        <!-- Right Card -->
        <div class="specs-card">
          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/cat.png" class="spec-icon">
              <span class="spec-label">Category</span>
            </div>
            <span class="spec-value">Kit</span>
          </div>
          <div class="spec-divider"></div>

          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/subcat.png" class="spec-icon">
              <span class="spec-label">Subcategory</span>
            </div>
            <span class="spec-value"> {{ kitTitle }}</span>
          </div>
          <div class="spec-divider"></div>

          <div class="spec-row">
            <div class="spec-left">
              <img _ngcontent-kdr-c321="" src="../../../../assets/images/productdetailsimage/warranty.png" class="spec-icon">
              <span class="spec-label">Warranty</span>
            </div>
            <span class="spec-value">12 Months</span>
          </div>
        </div>
      </div>
    </div>
    <div class="features-container">
          <h2 class="title">Why You Should Order From Autoverse</h2>


          <div class="features-row">
          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/genune.png" class="icon" />
          <h3>Genuine Products</h3>
          <p>100% authentic parts from authorized manufacturers with full warranty coverage</p>
          </div>


          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/fast.png" class="icon" />
          <h3>Fast Delivery</h3>
          <p>Express shipping options available with real-time tracking for your peace of mind</p>
          </div>


          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/expert.png" class="icon" />
          <h3>Expert Support</h3>
          <p>Professional assistance from certified technicians available for all queries</p>
          </div>
          </div>


          <div class="mini-features-row">
          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/fastD.png" class="mini-icon" />
          <h4>Fast Delivery</h4>
          <span>Available</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/return.png" class="mini-icon" />
          <h4>Easy Returns</h4>
          <span>Fast Refunds</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/best.png" class="mini-icon" />
          <h4>Best Price</h4>
          <span>Competitive</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/quality.png" class="mini-icon" />
          <h4>Quality</h4>
          <span>Guaranteed</span>
          </div>
          </div>
    </div>
    <div #compatabilityDiv >
        <div class="comapatable">
            <h3 class="faq-title">Check Compatibile Cars</h3>
            <mat-tab-group>
            <div *ngFor="let vehicle of compatability">
                <mat-tab [label]="vehicle[0]">
                <table  [ngClass]="isMobile ? 'toggle-comp-btnMobile' : 'toggle-comp-btn'">
                    <tr>
                    <th>Model</th>
                    <th>Fuel</th>
                    <th>Varient</th>
                    <th>Year</th>
                    </tr>
        
                    <tr *ngFor="let model of getVisibleModels(vehicle[1], vehicle[0]); let i = index">
                    <td>{{ model.model }}</td>
                    <td>{{ model.fuelType }}</td>
                    <td>{{ model.description }}</td>
                    <td>{{ model.yearFrom }}-{{ model.yearTo }}</td>
                    </tr>
                </table>
                <button (click)="toggleShowMore(vehicle[0])" 
                        [ngClass]="isMobile ? 'toggle-show-btnMobile' : 'toggle-show-btn'"
                        *ngIf="vehicle[1]?.length > 10" >
                    <div style="padding: 5px;">{{ showAllMap[vehicle[0]] ? 'Show Less' : 'Show More' }}</div>
                    <div style=" align-items: center; display: flex;">
                        <i class="material-icons" style="color: white; align-items: center;  display: flex;">
                            {{ showAllMap[vehicle[0]] ? 'expand_less' : 'expand_more' }}
                        </i>
                    </div>
                </button>
                </mat-tab>
            </div>
            
            </mat-tab-group>
        </div>
    </div>
  </div>
  <!-- END .page-wrapper -->
  <!-- Overlay -->
  <div class="popup-overlay" *ngIf="showPopup" (click)="closePopup()"></div>

  <!-- EMPTY STATE -->
  <div *ngIf="showEmptyState" class="empty-wrapper">

    <div class="empty-card">

      <!-- LEFT -->
      <div class="empty-left">
        <div class="placeholder-box">
          <img
            [src]="emptyStateImage"  [alt]="kitTitle + ' Empty State'" class="empty-image" (error)="emptyStateImage = kitDefaultImage"
          />
        </div>
      </div>

      <!-- RIGHT -->
      <div class="empty-right">

        <h2>🔍 {{ kitTitle }} Not Available Instantly</h2>

        <p class="sub-text">
          We couldn't find a ready-to-dispatch {{ kitTitle }} for this vehicle.
        </p>

        <div class="info-box">
          Don’t worry — we’ll help you find the right parts quickly.
        </div>

        <button class="btn-secondary" (click)="createClutchRequest()">
          📩 Create Request for  {{ kitTitle }}
        </button>
      </div>

    </div>
  </div>
  <div class="popup" *ngIf="isPopupOpen">
    <div class="popup-content order-success-sec">
      <!-- <button mat-button (click)="closePopup()">Close</button> -->
      <img src="{{ successIcon }}" alt="Success Icon">
      <!-- <button class="close-popup" (click)="closePopup()">×</button> -->
      <mat-icon class="close-popup" (click)="closePopup()">close</mat-icon>
      <h3 *ngIf="addMoreItemsId">Request Updated!</h3>
      <h3 *ngIf="!addMoreItemsId">Request Created!</h3>
      <!-- <p class="order-label"><span class="order-id">Request ID  {{response.data.requestId}}</span></p> -->
      <p class="order-label">
        <span class="order-id">
          Request ID 
          {{ updatePopupData?.requestId }}
        </span>
      </p>
      <p class="date">
        <span>
          <!-- {{ updatePopupData?.requestCreatedAt || response?.data?.requestCreatedAt | date:'dd MMM yyyy, hh:mm a':'GMT+1060' }} -->
             {{ updatePopupData?.requestCreatedAt | date:'dd MMM yyyy, hh:mm a':'GMT+1060' }}
        </span>
      </p>
      <p class="thank-you">Let us deliver an awesome experience!</p>
      <!-- <button class="goto-order" (click)="closePopup()">Track My Request </button> -->
      <button class="goto-order" (click)="goToRequestDetails()">
        Track My Request
      </button>
    </div>
  </div>
</div>

<!-- ================================================OEM OES UI======================================= -->

<div *ngIf="showOemOesDiv"  class="page-layout blank fullwidth oem-oes-layout" (scroll)="onScroll()" fusePerfectScrollbar style="height: 1px; overflow-y: scroll; margin-bottom: 5em;    top: 1px;    background: linear-gradient(45deg, #e2e8f8, #F8FAFF);" >
  <div class="page-wrapper" *ngIf="!showEmptyState">
    <!-- ===== HERO: 2-col grid (image left, info right) ===== -->
    <div class="product-hero">
      <!-- Left: Image Gallery -->
      <div class="product-gallery">
        <div class="main-image-wrapper">
          <div class="bdg-and-dscnt">
            <span class="badge-discount" *ngIf="selectedItem?.discount">  {{ selectedItem?.discount }}% off </span>
            <!-- ✅ INDICATIVE IMAGE TAG -->
            <div
              class="indicative-tag-wrapper"
              *ngIf="isIndicativeImage(selectedImage || kitDefaultImage)"
              (mouseenter)="showIndicativeInfo()"
              (mouseleave)="hideIndicativeInfo()"
            >
              <span class="indicative-tag" (click)="toggleIndicativeInfo($event)">
                <span class="info-icon"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1_13)">
                <path d="M12.25 6.5C12.25 3.32436 9.67564 0.75 6.5 0.75C3.32436 0.75 0.75 3.32436 0.75 6.5C0.75 9.67564 3.32436 12.25 6.5 12.25C9.67564 12.25 12.25 9.67564 12.25 6.5Z" stroke="#144579" stroke-width="1.2"/>
                <path d="M6.5 5.5V9" stroke="#144579" stroke-width="1.2" stroke-linecap="round"/>
                <path d="M6.5 4.59999C6.83137 4.59999 7.1 4.33136 7.1 3.99999C7.1 3.66862 6.83137 3.39999 6.5 3.39999C6.16863 3.39999 5.9 3.66862 5.9 3.99999C5.9 4.33136 6.16863 4.59999 6.5 4.59999Z" fill="#144579"/>
                </g>
                <defs>
                <clipPath id="clip0_1_13">
                <rect width="13" height="13" fill="white"/>
                </clipPath>
                </defs>
                </svg>
              </span> Indicative Image
              </span>

              <!-- Popup anchored right under the tag -->
              <div class="indicative-popup" *ngIf="isIndicativeTagOpen">
                This is a representative image. Actual product may vary in appearance.
              </div>
            </div>
          </div>
          <span class="badge-sold"  *ngIf="selectedItem?.raw?.partInfo?.soldCount">
            {{ selectedItem?.raw?.partInfo?.soldCount || 0 }} Units Sold
          </span>
          <span class="badge-stock">
            ⏳ Limited stock at JC Road
          </span>
          <!-- <img  [src]="selectedImage || defaultImage" [alt]="selectedItem?.partName" class="main-image"  (error)="onImageError($event)"  /> -->
          <img
            [src]="selectedImage || kitDefaultImage"
          [alt]="selectedItem?.partName"
          class="main-image"
          (error)="onHeroImageError($event)"
          />
        </div>
        <!-- Thumbnail Strip -->
        <div class="thumbnail-strip" *ngIf="clutchList?.length > 1">
          <div 
             class="thumbnail-item"
          *ngFor="let item of filteredClutchList"
          [ngClass]="{ active: item.image === selectedImage }"
          (click)="selectImage(item)"
          >
            <img [src]="item.image || defaultImage"  (error)="onThumbnailImageError($event)" />
          </div>
        </div>
      </div>
      <!-- Right: Product Info 1st ui -->
       <div *ngIf="isSingleKit">
        <div class="product-info">
          <h1 class="product-title">
             {{ formatTitle(pricingSummary?.title) || 'Clutch Product' }}
          </h1>
          <div class="rating-row">
            <!-- <span class="star">&#9733;</span>
            <span class="star">&#9733;</span>
            <span class="star">&#9733;</span>
            <span class="star">&#9733;</span>
            <span class="star">&#9733;</span> -->
            <span class="star" style="color: #000000;">⭐⭐⭐⭐⭐</span>
            <span class="rating-count">5 Ratings</span>
          </div>
          <div class="delivery-row">
            <svg class="truck-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
            </svg>
            <span class="delivery-text"> Dispatched in 15 Mins</span>
          </div>
          <div class="price-box">
            <div class="price-row">
                <span class="current-price">
                   ₹{{ selectedPricingSummary?.totalSellingPrice || 0 }}
                </span>
                <span class="original-price" *ngIf="selectedPricingSummary?.totalMrp">
                     ₹{{ selectedPricingSummary?.totalMrp }}
                </span>
                <div style="display: flex;    align-items: center;" *ngIf="selectedPricingSummary?.savings">
                  <img src="../../../../assets/images/productdetailsimage/save.png" style="margin: 10px;">
                  <span class="save-badge" >
                       Save ₹{{ selectedPricingSummary?.savings }}
                  </span>
              </div>
            </div>
            <p class="tax-note">Inclusive of all taxes</p>
          </div>
          <!-- OEM / OES Selection -->
          <div class="comparison-wrapper">
            <!-- OES -->
            <div  *ngIf="oesItem"
              class="comparison-card oes-card"
              [class.oes-active]="selectedKitType === 'OES'"
              (click)="selectKit('OES')">
              <div class="best-value">  BEST VALUE</div>
              <div class="type-label">OES</div>
              <div class="mrp">  MRP <span>₹{{ oesItem?.totalMrp }}</span></div>
              <div class="price">  ₹{{ oesItem?.totalSellingPrice }}</div>
              <div class="off"> {{ oesItem?.discount }}% OFF </div>
              <div class="save">  Save ₹{{  oesItem?.savings}}  </div>
              <div class="bottom-text">  Trusted Alternative </div>
            </div>
            <!-- OEM -->
            <div 
              class="comparison-card"
              [class.oem-active]="selectedKitType === 'OEM'"
              (click)="selectKit('OEM')">
              <div class="type-label">OEM</div>
              <div class="mrp"> MRP <span>₹{{ oemItem?.totalMrp }}</span></div>
              <div class="price">  ₹{{ oemItem?.totalSellingPrice }} </div>
              <div class="off">  {{ oemItem?.discount }}% OFF  </div>
              <div class="save"> Save ₹{{ oemItem?.savings }} </div>
              <div class="bottom-text"> Original Manufacturer</div>
            </div>
          </div>
          <!-- Footer -->
          <div class="footer-strip"  *ngIf="(oesItem?.totalSellingPrice || 0) < (oemItem?.totalSellingPrice || 0)"> OES saves ₹{{   (oemItem?.totalSellingPrice || 0)   - (oesItem?.totalSellingPrice || 0) }} extra vs OEM — Best choice for value!</div>
          <div class="footer-strip-txt" >Inclusive of all taxes</div>
          <!-- <div class="sticky-cta"   >
            <button class="btn-add-cart" (click)="onAddToCart()" #stickyBtn>
              ⚡ Order Complete Kit
            </button>
            <div class="evrythng">Everything included. No extra parts needed.</div>
          </div> -->




          <!-- <div class="oess-fixed-btn-wrapper" [ngClass]="{   'oem-theme': selectedKitType === 'OEM',   'oes-theme': selectedKitType === 'OES' }" #stickyBtn>
            <div class="oess-fixed-left">
              <div class="oess-selected-row">
                <span class="oess-green-dot"></span>
                <span class="oess-selected-text">{{ selectedKitType }} KIT SELECTED</span>

                <span class="oess-save-pill"
                  *ngIf="avxSelectedAddonCount === 0 && selectedKitType === 'OES' && (oesItem?.totalSellingPrice || 0) < (oemItem?.totalSellingPrice || 0)">
                  Save ₹{{ (oemItem?.totalSellingPrice || 0) - (oesItem?.totalSellingPrice || 0) }} vs OEM
                </span>
                <span class="oess-save-pill" *ngIf="avxSelectedAddonCount > 0">
                  ✔ +{{ avxSelectedAddonCount }}   {{ avxSelectedAddonCount === 1 ? 'Part' : 'Parts' }} Added
                </span>
              </div>

              <div class="oess-info-box">
                <span class="oess-ordering-label">YOU ARE ORDERING</span>
                <div class="oess-kit-name">
                  {{ selectedItem?.partName || 'Clutch Set + Release Bearing' }}
                  <ng-container *ngIf="avxSelectedAddonCount > 0">, {{ avxSelectedAddonNames }}</ng-container>
                </div>
                <div class="oess-warranty" *ngIf="avxSelectedAddonCount === 0">
                  ✔ Warranty Available
                </div>
              </div>
            </div>

            <div class="oess-fixed-right">
              <div class="oess-price-row">
                <div class="oess-price">
                  ₹{{ (pricingSummary?.totalSellingPrice || 0) + avxSelectedAddonAmount | number }}
                </div>
                <div class="oess-mrp">
                  ₹{{ (pricingSummary?.totalMrp || 0) + avxSelectedAddonMrp | number }}
                </div>
              </div>

              <button class="oess-order-btn" (click)="onAddToCart()">
                <div class="oess-btn-top" *ngIf="avxSelectedAddonCount === 0">
                  {{ selectedKitType === 'OEM' ? '🔵' : '🟢' }} Order {{ selectedKitType }}  {{ kitTitle }}
                </div>
                <div class="oess-btn-top" *ngIf="avxSelectedAddonCount > 0">
                  🛒 Order  {{ kitTitle }} Package
                </div>
              </button>

              <div class="oess-fitment-text" *ngIf="avxSelectedAddonCount === 0">
                ✔ Correct fitment for your vehicle
              </div>
              <div class="oess-fitment-text" *ngIf="avxSelectedAddonCount > 0">
                ✔ {{ selectedKitType }} Kit + {{ avxSelectedAddonCount }} Additional {{ avxSelectedAddonCount === 1 ? 'Part' : 'Parts' }} Included
              </div>
            </div>
          </div> -->


       <div class="oess-fixed-btn-wrapper" [ngClass]="{   'oem-theme': selectedKitType === 'OEM',   'oes-theme': selectedKitType === 'OES' }" #stickyBtn>
          <div class="view-cart-partent-btn">
            <!-- BEFORE adding -->
            <button
              *ngIf="!kitInCart"
              class="btn-add-cart"
              [ngClass]="{
                'oem-btn-add-cart': selectedKitType === 'OEM',
                'oes-btn-add-cart': selectedKitType === 'OES'
              }"
              (click)="onAddToCart()">
              <mat-icon>shopping_cart</mat-icon> Add to Cart
            </button>

            <!-- AFTER adding -->
            <div *ngIf="kitInCart" class="qty-cart-row">
              <div class="btn-group">
                <button class="button1" mat-raised-button (click)="decreaseKitQty()">
                  <mat-icon class="sidebuttons1">remove</mat-icon>
                </button>
                <input type="text" [value]="kitQty" readonly>
                <button class="button1" mat-raised-button (click)="increaseKitQty()">
                  <mat-icon class="sidebutton1">add</mat-icon>
                </button>
              </div>

              <button class="view-cart-btn" (click)="goToCart()"  [ngClass]="{
    'oem-view-cart-btn': selectedKitType === 'OEM',
    'oes-view-cart-btn': selectedKitType === 'OES'
  }">
                <span class="vc-left">
                  <!-- <span class="vc-item-count">{{ kitQty }} Item{{ getKitQty() > 1 ? 's' : '' }}</span> -->
                  <span class="vc-item-count">{{ kitSummaryLabel }}</span>
                  <span class="vc-amount">₹ {{ kitTotalAmount | number:'1.2-2' }}</span>
                </span>
                <span class="vc-right">View Cart</span>
              </button>
            </div>
          </div>

       </div>

          <!-- <div class="oess-fixed-btn-wrapper" #stickyBtn>
            <div class="oess-fixed-left">
              <div class="oess-selected-row">
                <span class="oess-green-dot"></span>
                <span class="oess-selected-text">
                  {{ selectedKitType }} KIT SELECTED
                </span>
              </div>
              <div class="oess-info-box">
                <span class="oess-ordering-label">
                  YOU ARE ORDERING
                </span>
                <div class="oess-kit-name">
                  {{ selectedItem?.partName || 'Clutch Set + Release Bearing' }}
                </div>
                <div class="oess-warranty">
                  ✔ Warranty Available
                </div>
              </div>
            </div>
            <div class="oess-fixed-right" >
              <div class="oess-price-row">
                <div class="oess-price">
                  ₹{{ pricingSummary?.totalSellingPrice || 0 }}
                </div>
                <div class="oess-save-pill" *ngIf=" selectedKitType === 'OES' && (oesItem?.totalSellingPrice || 0) < (oemItem?.totalSellingPrice || 0)">
                  Save ₹{{   (oemItem?.totalSellingPrice || 0)   - (oesItem?.totalSellingPrice || 0) }} vs OEM
                </div>
              </div>
              <button class="oess-order-btn"   (click)="onAddToCart()" >
                <div class="oess-btn-top">🟢 Order {{ selectedKitType }} Clutch Kit
                </div>
              </button>
              <div class="oess-fitment-text">
                ✔ Correct fitment for your vehicle
              </div>
            </div>
          </div> -->

        </div>
      </div>
      <!-- END .product-info -->
      <!-- Right: Product Info 2nd ui -->
       <div class="right-container" *ngIf="isFullKit">
        <div class="scrollable-content" #productSection>
          <div class="product-info">
            <h1 class="product-title">
               {{ formatTitle(pricingSummary?.title) || 'Clutch Product' }}
            </h1>

            <div class="rating-row">
              <!-- <span class="star">&#9733;</span>
              <span class="star">&#9733;</span>
              <span class="star">&#9733;</span>
              <span class="star">&#9733;</span>
              <span class="star">&#9733;</span> -->
              <span class="star" style="color: #000000;">⭐⭐⭐⭐⭐</span>
              <span class="rating-count">5 Ratings</span>
            </div>

            <div class="delivery-row">
              <!-- <svg class="truck-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
              </svg> -->
              <span class="delivery-text" *ngIf="avxSelectedAddonCount === 0">🚚 Dispatches in 15 mins — Ready to ship immediately</span>
            </div>
          <!-- OEM / OES Selection -->
          <div class="comparison-wrapper">
            <!-- OES -->
            <div 
              class="comparison-card oes-card"
              [class.oes-active]="selectedKitType === 'OES'"
              (click)="selectKit('OES')">
              <div class="best-value">  BEST VALUE</div>
              <div class="type-label">OES</div>
              <!-- <div class="mrp">  MRP ₹{{ oesItem?.totalMrp }}</div> -->
              <div class="mrp">  MRP <span>₹{{ oesItem?.totalMrp }}</span></div>
              <div class="price">  ₹{{ oesItem?.totalSellingPrice  }}</div>
              <div class="off"> {{ oesItem?.discount }}% OFF </div>
              <div class="save">  Save ₹{{ oesItem?.savings  }}  </div>
              <div class="bottom-text">  Trusted Alternative </div>
            </div>
            <!-- OEM -->
            <div 
              class="comparison-card"
              [class.oem-active]="selectedKitType === 'OEM'"
              (click)="selectKit('OEM')">
              <div class="type-label">OEM</div>
              <div class="mrp"> MRP <span>₹{{ oemItem?.totalMrp }}</span></div>
              <div class="price">  ₹{{ oemItem?.totalSellingPrice }} </div>
              <div class="off">  {{ oemItem?.discount }}% OFF  </div>
              <div class="save"> Save ₹{{ oemItem?.savings }} </div>
              <div class="bottom-text"> Original Manufacturer</div>
            </div>
          </div>
          <!-- Footer -->
          <div class="footer-strip"  *ngIf="(oesItem?.totalSellingPrice || 0) < (oemItem?.totalSellingPrice || 0)"> OES saves ₹{{   (oemItem?.totalSellingPrice || 0)   - (oesItem?.totalSellingPrice || 0) }} extra vs OEM — Best choice for value!</div>
          <div class="footer-strip-txt" >Inclusive of all taxes</div> 
          </div>
          <!-- <div class="sticky-cta"   >
            <button class="btn-add-cart" (click)="onAddToCart()" #stickyBtn>
              ⚡ Order Complete Kit
            </button>
            <div class="evrythng">Everything included. No extra parts needed.</div>
          </div> -->


          <div class="oess-fixed-btn-wrapper" [ngClass]="{   'oem-theme': selectedKitType === 'OEM',   'oes-theme': selectedKitType === 'OES' }"  #stickyBtn>
            <!-- <div class="oess-fixed-left">
              <div class="oess-selected-row">
                <span class="oess-green-dot"></span>
                <span class="oess-selected-text">{{ selectedKitType }} KIT SELECTED</span>

                <span class="oess-save-pill"
                  *ngIf="avxSelectedAddonCount === 0 && selectedKitType === 'OES' && (oesItem?.totalSellingPrice || 0) < (oemItem?.totalSellingPrice || 0)">
                  Save ₹{{ (oemItem?.totalSellingPrice || 0) - (oesItem?.totalSellingPrice || 0) }} vs OEM
                </span>
                <span class="oess-save-pill" *ngIf="avxSelectedAddonCount > 0">
                  ✔ +{{ avxSelectedAddonCount }}   {{ avxSelectedAddonCount === 1 ? 'Part' : 'Parts' }} Added
                </span>
              </div>

              <div class="oess-info-box">
                <span class="oess-ordering-label">YOU ARE ORDERING</span>
                <div class="oess-kit-name">
                  {{ selectedItem?.partName || 'Clutch Set + Release Bearing' }}
                  <ng-container *ngIf="avxSelectedAddonCount > 0">, {{ avxSelectedAddonNames }}</ng-container>
                </div>
                <div class="oess-warranty" *ngIf="avxSelectedAddonCount === 0">
                  ✔ Warranty Available
                </div>
              </div>
            </div>

            <div class="oess-fixed-right">
              <div class="oess-price-row">
                <div class="oess-price">
                  ₹{{ (pricingSummary?.totalSellingPrice || 0) + avxSelectedAddonAmount | number }}
                </div>
                <div class="oess-mrp" >
                  ₹{{ (pricingSummary?.totalMrp || 0) + avxSelectedAddonMrp | number }}
                </div>
              </div>

              <button class="oess-order-btn" (click)="onAddToCart()">
                <div class="oess-btn-top" *ngIf="avxSelectedAddonCount === 0">
                  {{ selectedKitType === 'OEM' ? '🔵' : '🟢' }} Order {{ selectedKitType }}  {{ kitTitle }}
                </div>
                <div class="oess-btn-top" *ngIf="avxSelectedAddonCount > 0">
                  🛒 Order  {{ kitTitle }} Package
                </div>
              </button>

              <div class="oess-fitment-text" *ngIf="avxSelectedAddonCount === 0">
                ✔ Correct fitment for your vehicle
              </div>
              <div class="oess-fitment-text" *ngIf="avxSelectedAddonCount > 0">
                ✔ {{ selectedKitType }} Kit + {{ avxSelectedAddonCount }} Additional {{ avxSelectedAddonCount === 1 ? 'Part' : 'Parts' }} Included
              </div>
            </div> -->
            <div class="view-cart-partent-btn">
              <!-- BEFORE adding -->
              <button
                *ngIf="!kitInCart"
                class="btn-add-cart"
                [ngClass]="{
                  'oem-btn-add-cart': selectedKitType === 'OEM',
                  'oes-btn-add-cart': selectedKitType === 'OES'
                }"
                (click)="onAddToCart()">
                <mat-icon>shopping_cart</mat-icon> Add to Cart
              </button>

              <!-- AFTER adding -->
              <div *ngIf="kitInCart" class="qty-cart-row">
                <div class="btn-group">
                  <button class="button1" mat-raised-button (click)="decreaseKitQty()">
                    <mat-icon class="sidebuttons1">remove</mat-icon>
                  </button>
                  <input type="text" [value]="kitQty" readonly>
                  <button class="button1" mat-raised-button (click)="increaseKitQty()">
                    <mat-icon class="sidebutton1">add</mat-icon>
                  </button>
                </div>

                <button class="view-cart-btn" (click)="goToCart()"  [ngClass]="{
                    'oem-view-cart-btn': selectedKitType === 'OEM',
                    'oes-view-cart-btn': selectedKitType === 'OES'
                  }">
                  <span class="vc-left">
                    <!-- <span class="vc-item-count">{{ kitQty }} Item{{ getKitQty() > 1 ? 's' : '' }}</span> -->
                    <span class="vc-item-count">{{ kitSummaryLabel }}</span>
                    <span class="vc-amount">₹ {{ kitTotalAmount | number:'1.2-2' }}</span>
                  </span>
                  <span class="vc-right">View Cart</span>
                </button>
              </div>
            </div>

          </div>


          
          <!-- <div class="oess-fixed-btn-wrapper" #stickyBtn  >
            <div class="oess-fixed-left">
              <div class="oess-selected-row">
                <span class="oess-green-dot"></span>
                <span class="oess-selected-text">
                  {{ selectedKitType }} KIT SELECTED
                </span>
              </div>
              <div class="oess-info-box">
                <span class="oess-ordering-label">
                  YOU ARE ORDERING
                </span>
                <div class="oess-kit-name">
                  {{ selectedItem?.partName || 'Clutch Set + Release Bearing' }}
                </div>
                <div class="oess-warranty">
                  ✔ Warranty Available
                </div>
              </div>
            </div>
            <div class="oess-fixed-right" >
              <div class="oess-price-row">
                <div class="oess-price">
                  ₹{{ pricingSummary?.totalSellingPrice || 0 }}
                </div>
                <div class="oess-save-pill" *ngIf=" selectedKitType === 'OES' && (oesItem?.totalSellingPrice || 0) < (oemItem?.totalSellingPrice || 0)">
                  Save ₹{{   (oemItem?.totalSellingPrice || 0)   - (oesItem?.totalSellingPrice || 0) }} vs OEM
                </div>
              </div>
              <button class="oess-order-btn"   (click)="onAddToCart()">
                <div class="oess-btn-top">🟢 Order {{ selectedKitType }} Clutch Kit
                </div>
              </button>
              <div class="oess-fitment-text">
                ✔ Correct fitment for your vehicle
              </div>
            </div>
          </div> -->
        </div>
        </div>
        <!-- <button  class="floating-cta"  [ngClass]="{    'oem-floating-cta': selectedKitType === 'OEM',    'oes-floating-cta': selectedKitType === 'OES'  }" *ngIf="showFloatingBtn" (click)="onAddToCart()"> ⚡ {{  avxSelectedAddonCount > 0  ? ('Order ' + kitTitle + ' Package')     : ('Order Complete ' + selectedKitType + ' ' + kitTitle) }} </button> -->
       <button
          class="floating-cta"
          [ngClass]="{
            'oem-floating-cta': selectedKitType === 'OEM',
            'oes-floating-cta': selectedKitType === 'OES'
          }"
          *ngIf="showFloatingBtn"
          (click)="onFloatingCtaClick()">

          <ng-container *ngIf="!kitInCart">
            <mat-icon>shopping_cart</mat-icon>
            Add {{ selectedKitType }} {{ kitTitle }}
          </ng-container>

          <ng-container *ngIf="kitInCart">
            ₹{{ kitTotalAmount | number:'1.0-0' }} · View Cart
          </ng-container>

        </button>
       <!-- END .product-info -->
    </div>
    <!-- END .product-hero -->
    <!-- ===== CLUTCH KIT UI SWITCH ===== -->
      <div class="kit-wrapper">

      <!-- ══════════════════════════════════════════
          SPLIT UI — 2 variables (!isFullKit)
      ══════════════════════════════════════════ -->
      <!-- WHAT YOU GET -->
      <div *ngIf="isSingleKit" class="kit-card split">
        <p  class="wht-u-get">
          WHAT YOU GET IN THIS KIT
        </p>
        <div class="kit-selection-tabs">
          <div class="kit-tab" [class.oes-active]="selectedKitType === 'OES'" (click)="selectKit('OES')">
            OES Kit
          </div>
          <div class="kit-tab"[class.oem-active]="selectedKitType === 'OEM'" (click)="selectKit('OEM')">
            OEM Kit
          </div>
        </div>
        <!-- ITEMS LIST -->
        <div class="parts-wrapper">
          <div *ngFor="let item of selectedItem?.items"  class="parts-inld">
            <div class="prt-nms">

              <span *ngIf="item.partName?.toLowerCase().includes('disc')">
                💿
              </span>

              <span *ngIf="
                  !item.partName?.toLowerCase().includes('disc') &&
                  (
                    item.partName?.toLowerCase().includes('cover') ||
                    item.partName?.toLowerCase().includes('plate')
                  )
                ">
                🔧
              </span>

              <span *ngIf="
                  !item.partName?.toLowerCase().includes('disc') &&
                  !item.partName?.toLowerCase().includes('cover') &&
                  !item.partName?.toLowerCase().includes('plate') &&
                  item.partName?.toLowerCase().includes('bearing')
                ">
                ⚙️
              </span>

              <span
                *ngIf="
                  !item.partName?.toLowerCase().includes('disc') &&
                  !item.partName?.toLowerCase().includes('cover') &&
                  !item.partName?.toLowerCase().includes('plate') &&
                  !item.partName?.toLowerCase().includes('bearing') &&
                  (
                    item.partName?.toLowerCase().includes('flywheel') ||
                    item.partName?.toLowerCase().includes('fly wheel')
                  )
                "
                style="display: inline-flex; align-items: center; padding: 3px;"
              >
                <img
                  src="../../../../assets/images/clutch-flyingwheel.png"
                  class="part-icon"
                  style="width: 20px;"
                >
              </span>

              <span *ngIf="
                  !item.partName?.toLowerCase().includes('disc') &&
                  !item.partName?.toLowerCase().includes('cover') &&
                  !item.partName?.toLowerCase().includes('plate') &&
                  !item.partName?.toLowerCase().includes('bearing') &&
                  !item.partName?.toLowerCase().includes('flywheel') &&
                  !item.partName?.toLowerCase().includes('fly wheel')
                ">
                ⚙️
              </span>

              {{ item.partName }}

            </div>
            <div class="inld">
              Included
            </div>
          </div>
        </div>
         <div class="clutch-set-bran-main">
            <!-- Brand -->
            <div class="clutch-set-brand">
              <span>🏷️ Brand: </span>
              <span class="clutch-set-brand-sub">
                {{ brandText }}
              </span>
            </div>
            <!-- Part Numbers -->
            <div class="clutch-set-brand">
              <span>🔩 Part: </span>
              <span class="clutch-set-brand-sub">
                {{ partNumberText }}
              </span>
            </div>
            <!-- Types -->
            <div class="clutch-set-brand">
              <span>🟢 Type:</span>
              <span class="clutch-set-brand-sub">
                {{ partTypeText }}
              </span>
            </div>
          </div>
      </div>
      <div *ngIf="isFullKit" class="kit-card split">
            <p  class="wht-u-get">WHAT YOU GET IN THIS KIT </p>
            <div class="kit-selection-tabs">
              <div class="kit-tab" [class.oes-active]="selectedKitType === 'OES'" (click)="selectKit('OES')">
                OES Kit
              </div>
              <div class="kit-tab"[class.oem-active]="selectedKitType === 'OEM'" (click)="selectKit('OEM')">
                OEM Kit
              </div>
            </div>
            <div class="split-row-parent">
                <div class="split-row" *ngFor="let item of selectedItem?.items"  [ngClass]="{     'full-width': selectedItem?.items?.length === 1,    'half-width': selectedItem?.items?.length > 1   }" >
                  <div class="row-top" style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px;">

                    <div class="left" style="display: flex; gap: 10px; flex: 1; min-width: 0;">
                      <!-- ICON -->
                      <!-- Clutch Set -->
                      <div
                        class="icons"
                        *ngIf="item.partName?.toLowerCase().includes('clutch set')"
                      >
                        <div class="icon bg-yellow">💿</div>
                        <div class="icon bg-blue">⚙️</div>
                      </div>
                      <!-- Disc -->
                      <div
                        class="icon bg-yellow"
                        *ngIf="
                          !item.partName?.toLowerCase().includes('clutch set') &&
                          item.partName?.toLowerCase().includes('disc')
                        "
                      >
                        💿
                      </div>
                      <!-- Cover / Plate -->
                      <div
                        class="icon bg-gray"
                        *ngIf="
                          !item.partName?.toLowerCase().includes('clutch set') &&
                          !item.partName?.toLowerCase().includes('disc') &&
                          (
                            item.partName?.toLowerCase().includes('cover') ||
                            item.partName?.toLowerCase().includes('plate')
                          )
                        "
                      >
                        🔩
                      </div>
                      <!-- Bearing -->
                      <div
                        class="icon bg-blue"
                        *ngIf="
                          !item.partName?.toLowerCase().includes('clutch set') &&
                          !item.partName?.toLowerCase().includes('disc') &&
                          !item.partName?.toLowerCase().includes('cover') &&
                          !item.partName?.toLowerCase().includes('plate') &&
                          item.partName?.toLowerCase().includes('bearing')
                        "
                      >
                        🔩
                      </div>
                      <!-- Default -->
                      <div
                        class="icon bg-blue"
                        *ngIf="
                          !item.partName?.toLowerCase().includes('clutch set') &&
                          !item.partName?.toLowerCase().includes('disc') &&
                          !item.partName?.toLowerCase().includes('cover') &&
                          !item.partName?.toLowerCase().includes('plate') &&
                          !item.partName?.toLowerCase().includes('bearing')
                        "
                      >
                        🔩
                      </div>
                      <div style="width: 100%; gap: 10px;">

                        <div class="info" style="flex: 1; min-width: 0;">

                          <div class="top-line" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">

                            <h4>{{ item?.partName || 'Part' }}</h4>

                            <span
                              class="type-tag"
                              [ngClass]="item?.partType === 'OEM' ? 'oem-tag' : 'oes-tag'"
                            >
                              {{ item?.partType }}
                            </span>

                          </div>

                          <span class="sub">
                            🏭<span class="label">Brand:</span>
                            <span class="value">{{ item?.brand || '-' }}</span>
                          </span>

                          <span class="sub">
                            🔢 <span class="label">Part Number:</span>
                            <span class="value">{{ item?.partNumber || item?.partNo || '-' }}</span>
                          </span>

                        </div>

                        <div class="right">

                          <span class="price-val">
                            ₹{{ (item?.sellingPrice || 0).toFixed(2) }}

                            <span class="mrp" *ngIf="item?.mrp" style="text-decoration: line-through;">
                              ₹{{ (item?.mrp).toFixed(2) }}
                            </span>
                          </span>

                          <!-- <span class="price-tag">
                            {{ item?.partName || 'Part' }} price
                          </span> -->

                        </div>

                      </div>

                    </div>

                  </div>

                </div>
            </div>
      </div>
      <div *ngIf="isFullKit" class="kit-card split">
          <!-- <div class="included-bar">✅ Complete kit (
            <ng-container *ngFor="let item of clutchList; let last = last; let i = index">
              
              {{ item?.partName }}
              
              <span *ngIf="!last">
                +
              </span>

            </ng-container>
            included)
          </div> -->
          <div class="included-bar">✅ Complete kit (
            <ng-container *ngFor="let name of getUniquePartNames(); let last = last">
              {{ name }}
              <span *ngIf="!last"> + </span>
            </ng-container>
            included)
          </div>

          <!-- PRICE BREAKDOWN BOX -->
          <div class="oess-price-breakdown-card">
            <div class="oess-price-breakdown-title-row">
              <!-- <span class="oess-price-breakdown-bar"></span> -->

              <div class="oess-price-breakdown-title">
                PRICE BREAKDOWN
              </div>
            </div>
            <div class="oess-price-breakdown-grid">
               <!-- OES CARD -->
              <div class="oess-price-box oes-box" *ngIf="oesParts?.length">
                <div class="oess-price-box-header">
                  <span class="oes-dot"></span>
                  <span class="oess-price-box-title">OES</span>
                </div>
                <div class="oess-price-row"  *ngFor="let item of oesParts">
                  <span class="oess-label">{{ item?.partName }}</span>
                  <div class="ryt-txt">
                    <span class="oess-value">₹{{ item?.sellingPrice | number:'1.0-0' }}</span>
                    <span class="mrp" *ngIf="item?.mrp" style="text-decoration: line-through;">    ₹{{ item?.mrp | number:'1.0-0' }} </span>
                  </div>
                </div>
                <!-- <div class="oess-price-row">
                  <span class="oess-label">Bearing</span>
                  <span class="oess-value">₹334</span>
                </div> -->
                <div class="oess-divider"></div>
                <div class="oess-price-row total-row">
                  <span class="oess-total-label">Total</span>
                  <div class="ryt-txt">
                    <span class="oess-total-value"> ₹{{ oesItem?.totalSellingPrice | number:'1.0-0' }} </span>
                    <span class="mrp" style="text-decoration: line-through;"> ₹{{ oesItem?.totalMrp | number:'1.0-0' }} </span>
                  </div>
                </div>

              </div>
              <!-- OEM CARD -->
              <div class="oess-price-box oem-box" *ngIf="oemParts?.length">
                <div class="oess-price-box-header">
                  <span class="oem-dot"></span>
                  <span class="oess-price-box-title">OEM</span>
                </div>
                <div class="oess-price-row" *ngFor="let item of oemParts">
                  <span class="oess-label">{{ item?.partName }}</span>
                  <div class="ryt-txt">
                    <span class="oess-value">₹{{ item?.sellingPrice | number:'1.0-0' }}</span>
                    <span class="mrp" *ngIf="item?.mrp" style="text-decoration: line-through;">    ₹{{ item?.mrp | number:'1.0-0' }} </span>
                  </div>

                </div>
                <!-- <div class="oess-price-row">
                  <span class="oess-label">Bearing</span>
                  <span class="oess-value">₹447</span>
                </div> -->
                <div class="oess-divider"></div>
                <div class="oess-price-row total-row">
                  <span class="oess-total-label">Total</span>
                  <div class="ryt-txt">
                    <span class="oess-total-value">  ₹{{ oemItem?.totalSellingPrice | number:'1.0-0' }} </span>
                    <span class="mrp"  style="text-decoration: line-through;">    ₹{{  oemItem?.totalMrp | number:'1.0-0' }} </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- SAVE SECTION -->
            <div class="oess-save-strip" *ngIf="(oesItem?.totalSellingPrice || 0) < (oemItem?.totalSellingPrice || 0)">

              <div class="oess-save-left">
                <span class="oess-save-icon">🏷️</span>

                <span class="oess-save-text">
                  You save   ₹{{(oemItem?.totalSellingPrice - oesItem?.totalSellingPrice)     | number:'1.0-0'   }}  with OES
                </span>
              </div>

              <div class="oess-save-pill">
                 {{ ( (     (oemItem?.totalSellingPrice - oesItem?.totalSellingPrice)    / oemItem?.totalSellingPrice     ) * 100  ) | number:'1.0-0'  }}% OFF
              </div>

            </div>
          </div>
      </div>
      <div class="compare-section" *ngIf="isFullKit">
            <p class="compare-heading">
              COMPARE YOUR OPTIONS
            </p>
            <div class="compare-wrapper">
              <!-- OES CARD -->
              <div class="compare-card oes-card"  *ngIf="oesItem?.items?.length"  [class.oes-active]="selectedKitType === 'OES'" (click)="selectKit('OES')">
                <div class="top-row">
                  <div class="left-tags">
                    <div class="tag green">
                      <span class="dot"></span>
                      OES
                    </div>
                    <div class="selected-tag"  *ngIf="selectedKitType === 'OES'">  SELECTED</div>
                  </div>
                  <div class="ryt-txt">
                    <div class="top-price green-price">  ₹{{ oesItem?.totalSellingPrice || 0 }} </div>
                    <span class="mrp" style="text-decoration: line-through;"> ₹{{ oesItem?.totalMrp | number:'1.0-0' }} </span>
                  </div>
                </div>
                <h3>Trusted Alternative Option</h3>
                <p class="sub-text">  Better savings with trusted aftermarket brands. Same fitment guaranteed.  </p>
                <div class="save-strip"  *ngIf="(oesItem?.totalSellingPrice || 0) < (oemItem?.totalSellingPrice || 0)">💰 You save   ₹{{ oemItem?.totalSellingPrice - oesItem?.totalSellingPrice }}    compared to OEM option</div>
                <div class="badge-row">
                  <div class="badge green">✅ Available</div>
                  <div class="badge light">🚚 15 mins dispatch</div>
                </div>
                <div class="info-grid">
                  <div class="info-box" *ngIf="hasSameBrand(oesItem?.items)">
                    <span>Brand</span>
                    <strong>{{ oesBrands || '-' }}</strong>
                  </div>
                  <div class="info-box">
                    <span>Part Type</span>
                    <strong>OES</strong>
                  </div>
                  <div class="info-box">
                    <span>Warranty</span>
                    <strong>✅ Available</strong>
                  </div>
                  <div class="info-box">
                    <span>Fitment</span>
                    <strong>Exact Match</strong>
                  </div>
                </div>
                <div class="bottom-price-row">
                  <div class="ryt-txt">
                    <div class="price green-price">₹{{oesItem?.totalSellingPrice || 0 }}</div>
                    <div class="mrp" style="text-decoration: line-through;">₹{{ oesItem?.totalMrp }}</div>
                  </div>
                  <div class="tax-text"> Inclusive of all taxes </div>
                </div>
                <button class="select-btn active-btn"> Select OES Quote </button>
              </div>
              <!-- OEM CARD -->
              <div class="compare-card oem-card"  *ngIf="oemItem?.items?.length" [class.oem-active]="selectedKitType === 'OEM'"  (click)="selectKit('OEM')">
                <div class="top-row">
                  <div class="left-tags">
                    <div class="tag blue">
                      <span class="dot"></span>
                      OEM
                    </div>
                    <div class="selected-tag"  *ngIf="selectedKitType === 'OEM'">  SELECTED</div>
                  </div>
                  <div class="ryt-txt">
                    <div class="top-price">  ₹{{ oemItem?.totalSellingPrice || 0 }}</div>
                    <div  class="mrp" style="text-decoration: line-through;">  ₹{{ oemItem?.totalMrp || 0 }}</div>
                  </div>
                </div>
                <h3>Original Manufacturer Option</h3>
                <p class="sub-text">  Recommended for users preferring original manufacturer parts.   </p>
                <div class="badge-row">
                  <div class="badge green">✅ Available</div>
                  <div class="badge light">🚚 15 mins dispatch</div>
                </div>
                <div class="info-grid">
                  <div class="info-box" *ngIf="hasSameBrand(oemItem?.items)">
                    <span>Brand</span>
                    <strong>{{ oemBrands || '-' }}</strong>
                  </div>
                  <div class="info-box">
                    <span>Part Type</span>
                    <strong>OEM</strong>
                  </div>
                  <div class="info-box">
                    <span>Warranty</span>
                    <strong>✅ Available</strong>
                  </div>
                  <div class="info-box">
                    <span>Fitment</span>
                    <strong>Exact Match</strong>
                  </div>
                </div>
                <div class="bottom-price-row">
                  <div class="ryt-txt">
                    <div class="price"> ₹{{ oemItem?.totalSellingPrice || 0 }}</div>
                    <div class="mrp" style="text-decoration: line-through;">₹{{ oemItem?.totalMrp }}</div>
                  </div>
                  <div class="tax-text">Inclusive of all taxes</div>
                </div>
                <button class="select-btn"  [class.active-btn]="selectedKitType === 'OEM'">  Select OEM Quote  </button>
              </div>
            </div>
      </div>

      <!-- ══════════════════════════════════════════
          FULL KIT UI — 1 variable (isFullKit)
      ══════════════════════════════════════════ -->
      <div class="compare-section" *ngIf="isSingleKit">
        <p class="compare-heading">
          COMPARE YOUR OPTIONS
        </p>
        <div class="compare-wrapper">
          <!-- OES CARD -->
          <div class="compare-card oes-card"  *ngIf="oesItem?.items?.length" [class.oes-active]="selectedKitType === 'OES'" (click)="selectKit('OES')">
            <div class="top-row">
              <div class="left-tags">
                <div class="tag green">
                  <span class="dot"></span>
                  OES
                </div>
                <div class="selected-tag" *ngIf="selectedKitType === 'OES'"> SELECTED  </div>
              </div>
              <div class="ryt-txt">
                <div class="top-price green-price"> ₹{{ oesItem?.totalSellingPrice || 0 }} </div>
                <span class="mrp" style="text-decoration: line-through;"> ₹{{ oesItem?.totalMrp | number:'1.0-0' }} </span>
              </div>
            </div>
            <h3>Trusted Alternative Option</h3>
            <p class="sub-text">  Better savings with trusted aftermarket brands. Same fitment guaranteed.  </p>
            <div class="save-strip"  *ngIf="oemItem?.totalSellingPrice > oesItem?.totalSellingPrice">💰 You save  ₹{{ oemItem?.totalSellingPrice - oesItem?.totalSellingPrice }}  compared to OEM option</div>
            <div class="badge-row">
              <div class="badge green">✅ Available</div>
              <div class="badge light">🚚 15 mins dispatch</div>
            </div>
            <div class="info-grid">
              <div class="info-box" *ngIf="hasSameBrand(oesItem?.items)">
                <span>Brand</span>
                <strong>{{ oesBrands || '-' }}</strong>
              </div>
              <div class="info-box">
                <span>Part Type</span>
                <strong>OES</strong>
              </div>
              <div class="info-box">
                <span>Warranty</span>
                <strong>✅ Available</strong>
              </div>
              <div class="info-box">
                <span>Fitment</span>
                <strong>Exact Match</strong>
              </div>
            </div>
            <div class="bottom-price-row">
              <div class="ryt-txt">
                <div class="price green-price">₹{{ oesItem?.totalSellingPrice || 0}}</div>
                <div class="mrp" style="text-decoration: line-through;">₹{{ oesItem?.totalMrp }}</div>
              </div>
              <div class="tax-text"> Inclusive of all taxes </div>
            </div>
            <button class="select-btn active-btn" [class.active-btn]="selectedKitType === 'OES'"> Select OES Quote </button>
          </div>
          <!-- OEM CARD -->
          <div class="compare-card oem-card"  *ngIf="oemItem?.items?.length" [class.oem-active]="selectedKitType === 'OEM'"  (click)="selectKit('OEM')">
            <div class="top-row">
              <div class="tag blue">
                <span class="dot"></span>
                OEM
              </div>
              <div class="ryt-txt">
                <div class="top-price"> ₹{{ pricingSummary?.OEM?.totalSellingPrice || 0 }} </div>
                <div class="mrp" style="text-decoration: line-through;">₹{{ pricingSummary?.OEM?.totalMrp }}</div>
              </div>
            </div>
            <h3>Original Manufacturer Option</h3>
            <p class="sub-text">  Recommended for users preferring original manufacturer parts.   </p>
            <div class="badge-row">
              <div class="badge green">✅ Available</div>
              <div class="badge light">🚚 15 mins dispatch</div>
            </div>
            <div class="info-grid">
              <div class="info-box" *ngIf="hasSameBrand(oemItem?.items)">
                <span>Brand</span>
                <strong>{{ oemBrands || '-' }}</strong>
              </div>
              <div class="info-box">
                <span>Part Type</span>
                <strong>OEM</strong>
              </div>
              <div class="info-box">
                <span>Warranty</span>
                <strong>✅ Available</strong>
              </div>
              <div class="info-box">
                <span>Fitment</span>
                <strong>Exact Match</strong>
              </div>
            </div>
            <div class="bottom-price-row">
              <div class="ryt-txt">
                <div class="price">₹{{ oemItem?.totalSellingPrice }}</div>
                <div class="mrp" style="text-decoration: line-through;">₹{{ oemItem?.totalMrp }}</div>
              </div>
              <div class="tax-text">Inclusive of all taxes</div>
            </div>
            <button class="select-btn"  [class.active-btn]="selectedKitType === 'OEM'">  Select OEM Quote  </button>
          </div>
        </div>
      </div>
      <div class="pit-oes-wrapper" *ngIf="oesItem?.items?.length">
        <div class="pit-oes-title-section">
          <h3 class="pit-oes-title-text">WHY CHOOSE OES?</h3>
        </div>
        <div class="pit-oes-feature-card">
          <div class="pit-oes-icon">✅</div>
          <div class="pit-oes-content">
            <div class="pit-oes-heading">  Same Fitment Guaranteed</div>
            <div class="pit-oes-subtext"> Designed to fit your car exactly like OEM </div>
          </div>
        </div>
        <div class="pit-oes-feature-card" *ngIf="oemItem?.totalSellingPrice > oesItem?.totalSellingPrice">
          <div class="pit-oes-icon">💰</div>
          <div class="pit-oes-content">
            <div class="pit-oes-heading">  Save ₹{{ oemItem?.totalSellingPrice - oesItem?.totalSellingPrice  }} Instantly </div>
            <div class="pit-oes-subtext">  More savings, same quality performance </div>
          </div>
        </div>
        <div class="pit-oes-feature-card pit-oes-feature-last">
          <div class="pit-oes-icon">🏭</div>
          <div class="pit-oes-content">
            <div class="pit-oes-heading"> Trusted Global Brands </div>
            <div class="pit-oes-subtext">  Sachs & Valeo are world-class OES suppliers </div>
          </div>
        </div>
      </div>
      <div class="pit-share-quote-container">
        <div class="pit-share-quote-title">
          QUOTE SUMMARY
        </div>
        <div class="pit-share-quote-card" (click)="shareOnWhatsApp()">
          <div class="pit-share-quote-left">
            <div class="pit-share-quote-icon">
              <img src="../../../../assets/images/whats-app-icon/whats-app-icon-image.png" alt="whatsapp">
            </div>
            <div class="pit-share-quote-content">
              <div class="pit-share-quote-heading">
                Share Quote on WhatsApp
              </div>
              <div class="pit-share-quote-subtext">
                Send OEM & OES comparison instantly.
              </div>
              <div class="pit-share-quote-note">
                Includes live comparison link
              </div>
            </div>
          </div>
          <button class="pit-share-quote-btn">
            <img src="../../../../assets/images/whats-app-icon/whats-app-icon-image.png" alt="whatsapp">
            <span>Share Comparison</span>
          </button>
        </div>
        <div class="pit-share-quote-footer">
          The comparison link will open in WhatsApp with the quote pre-filled.
        </div>
      </div>
      <div  class="kit-card full">
          <p class="section-title top-gap">DELIVERY TIMELINE</p>
          <div class="delivery-row">
            <div class="delivery-card blue" *ngIf="avxSelectedAddonCount === 0">
                <div class="d-icon">⏱️</div>
                <p>Ready in 15 mins</p>
                <span>Dispatch time</span>
            </div>
            <div class="delivery-card green" *ngIf="avxSelectedAddonCount === 0">
                <div class="d-icon">🚚</div>
                <p>Free Shipping</p>
                <span>To your location</span>
            </div>
          </div>
          <div class="benefits">
            <div>🛡️ Warranty Certificate Included</div>
            <div>✅ 100% Genuine Parts</div>
          </div>
          <div class="stock-warning">⚡ Limited stock at JC Road</div>
      </div>
        <!-- ========================================clutch-addon-section================= -->
         <div class="avx-clutch-addon-section" *ngIf="avxAddonParts?.length > 0">

          <div class="avx-clutch-addon-header">
            <div class="avx-clutch-addon-header-left">
              <div>
                <div class="avx-clutch-addon-title">Add Other {{ kitTitle }} Related Parts <span class="avx-clutch-addon-badge">Optional</span></div>
                <div class="avx-clutch-addon-description">Add additional {{ kitTitle }} related parts if needed. Users can independently choose OEM or OES for each part.</div>
              </div>
            </div>

            <label class="avx-select-all">
              <input type="checkbox" [(ngModel)]="avxAddonSelectAll" (change)="avxToggleSelectAllAddons()">
              <span>Select All</span>
            </label>
          </div>

          <div class="avx-cards-wrapper">

            <button class="avx-scroll-btn avx-scroll-left" (click)="!isAtStart && avxScrollAddonCards('left')"  [disabled]="isAtStart">
              <mat-icon>chevron_left</mat-icon>
            </button>

            <div class="avx-clutch-addon-cards"  (scroll)="onAddonCardsScroll()" [class.avx-addon-center]="avxAddonParts?.length < 4" #avxAddonCards>

              <div class="avx-clutch-addon-card" *ngFor="let part of avxAddonParts"
                [ngClass]="[part.colorClass,part.selected ? 'avx-clutch-addon-selected' : '']">

                <div class="avx-clutch-addon-top">
                  <div class="avx-card-radio" (click)="avxToggleAddonSelection(part)">
                    <mat-icon *ngIf="part.selected">check</mat-icon>
                  </div>
                  <span class="avx-card-discount" *ngIf="part?.discount > 0">
                      🏷️ {{ part.discount }}% OFF
                  </span>
                  <div class="avx-card-code">
                    <img
                       [src]="part.productImageUrl ? part.productImageUrl : defaultImage"
                      [alt]="part.partName"  (error)="onImageError($event)"
                    />
                  </div>
                </div>
              
                <div class="avx-clutch-addon-body">

                  <div class="avx-part-title">{{part.partName }}</div>

                  <div class="avx-part-info"><div class="avx-part-label">🏭 Brand: </div><div class="avx-part-value">{{part.brand}}</div></div>
                  <div class="avx-part-info"><div class="avx-part-label">🔩 Part No: </div><div class="avx-part-value">{{part.partNumber }}</div></div>

                  <div class="avx-option-toggle" [class.avx-toggle-disabled]="!hasBothOptions(part)">
                    <button type="button" class="avx-toggle-btn" [class.avx-oes-active]="part.selectedOption==='OES'"  [disabled]="!hasBothOptions(part)" (click)="avxSwitchAddonOption(part,'OES')">OES</button>
                    <button type="button" class="avx-toggle-btn" [class.avx-oem-active]="part.selectedOption==='OEM'"  [disabled]="!hasBothOptions(part)" (click)="avxSwitchAddonOption(part,'OEM')">OEM</button>
                  </div>

                  <div class="avx-price-row">
                    <div class="avx-selling-price">₹{{part.sellingPrice  | number:'1.0-2'}}</div>
                    <div class="avx-mrp">₹{{part.mrp | number:'1.0-2'}}</div>
                  </div>

                  <div class="avx-save-line" *ngIf="part.saveAmount>0">💰 Save ₹{{part.saveAmount | number:'1.0-2' }} vs MRP</div>

                  <div class="avx-compare-box" [ngClass]="{   'avx-compare-oem': part.selectedOption === 'OEM',   'avx-compare-oes': part.selectedOption === 'OES'    }"   *ngIf="part.compareSave > 0">
                    <div class="avx-compare-title">
                      <ng-container *ngIf="part.selectedOption === 'OEM'; else oesText">
                       ⚖️ OES could save ₹{{ part.compareSave | number:'1.2-2' }}
                      </ng-container>

                      <ng-template #oesText>
                       💸 Save ₹{{ part.compareSave | number:'1.2-2' }} vs OEM
                      </ng-template>
                    </div>

                    <div class="avx-compare-subtitle">Better value • same fitment</div>
                  </div>

                  <button type="button" class="avx-kit-btn" [class.avx-kit-added]="part.selected" (click)="avxToggleAddonSelection(part)">
                    <mat-icon class="avx-kit-icon">
                      {{ part.selected ? 'check' : 'add_circle_outline' }}
                    </mat-icon>
                    {{part.selected ? 'Added to Kit' : 'Add to Kit'}}
                  </button>

                </div>
              </div>

            </div>

            <button class="avx-scroll-btn avx-scroll-right" (click)="!isAtEnd && avxScrollAddonCards('right')"  [disabled]="isAtEnd">
              <mat-icon>chevron_right</mat-icon>
            </button>

          </div>

          <div class="avx-summary-section"  *ngIf="avxSelectedAddonCount > 0">
            <div>
              <div class="avx-summary-label">Parts Added to Kit</div>
              <div class="avx-summary-value">{{avxSelectedAddonCount}} Parts • ₹{{avxSelectedAddonAmount | number}}</div>
            </div>

            <div class="avx-summary-right">
              <div class="avx-summary-label">Total Savings</div>
              <div class="avx-summary-saving">₹{{avxSelectedAddonSavings | number}}</div>
            </div>
          </div>
          <div class="avx-price-note">
            <mat-icon>info</mat-icon>
            Prices are inclusive of taxes. Final pricing updates instantly based on selected parts and OEM/OES selection.
          </div>
        </div>
      </div>

    <!-- ===== PRODUCT SPECIFICATIONS — full width, outside grid ===== -->
    <div class="specs-section">
        <h2 class="specs-heading">Product Specifications</h2>

        <div class="specs-grid">

          <div class="specs-card">

            <!-- CATEGORY -->
            <div class="spec-row">
              <div class="spec-left">
                <img
                  src="../../../../assets/images/productdetailsimage/cat.png"
                  class="spec-icon"
                >
                <span class="spec-label">Category</span>
              </div>

              <span class="spec-value">
                Kit
                <!-- {{ activeItem?.partCategory || 'Clutch System' }} -->
              </span>
            </div>

            <div class="spec-divider"></div>

            <!-- SUBCATEGORY -->
            <div class="spec-row">
              <div class="spec-left">
                <img
                  src="../../../../assets/images/productdetailsimage/subcat.png"
                  class="spec-icon"
                >
                <span class="spec-label">Subcategory</span>
              </div>

              <span class="spec-value">
                {{ kitTitle }}
              </span>
            </div>

            <div class="spec-divider"></div>

            <!-- WARRANTY -->
            <div class="spec-row">
              <div class="spec-left">
                <img
                  src="../../../../assets/images/productdetailsimage/warranty.png"
                  class="spec-icon"
                >
                <span class="spec-label">Warranty</span>
              </div>

              <span class="spec-value">
                {{ activeItem?.warranty || '12 Months' }}
              </span>
            </div>

          </div>

        </div>
    </div>
    <div class="features-container">
          <h2 class="title">Why You Should Order From Autoverse</h2>


          <div class="features-row">
          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/genune.png" class="icon" />
          <h3>Genuine Products</h3>
          <p>100% authentic parts from authorized manufacturers with full warranty coverage</p>
          </div>


          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/fast.png" class="icon" />
          <h3>Fast Delivery</h3>
          <p>Express shipping options available with real-time tracking for your peace of mind</p>
          </div>


          <div class="feature-box">
          <img src="../../../../assets/images/productdetailsimage/expert.png" class="icon" />
          <h3>Expert Support</h3>
          <p>Professional assistance from certified technicians available for all queries</p>
          </div>
          </div>


          <div class="mini-features-row">
          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/fastD.png" class="mini-icon" />
          <h4>Fast Delivery</h4>
          <span>Available</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/return.png" class="mini-icon" />
          <h4>Easy Returns</h4>
          <span>Fast Refunds</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/best.png" class="mini-icon" />
          <h4>Best Price</h4>
          <span>Competitive</span>
          </div>


          <div class="mini-feature">
          <img src="../../../../assets/images/productdetailsimage/quality.png" class="mini-icon" />
          <h4>Quality</h4>
          <span>Guaranteed</span>
          </div>
          </div>
    </div>
    <div #compatabilityDiv >
        <div class="comapatable">
            <h3 class="faq-title">Check Compatibile Cars</h3>
            <mat-tab-group>
            <div *ngFor="let vehicle of compatability">
                <mat-tab [label]="vehicle[0]">
                <table  [ngClass]="isMobile ? 'toggle-comp-btnMobile' : 'toggle-comp-btn'">
                    <tr>
                    <th>Model</th>
                    <th>Fuel</th>
                    <th>Varient</th>
                    <th>Year</th>
                    </tr>
        
                    <tr *ngFor="let model of getVisibleModels(vehicle[1], vehicle[0]); let i = index">
                    <td>{{ model.model }}</td>
                    <td>{{ model.fuelType }}</td>
                    <td>{{ model.description }}</td>
                    <td>{{ model.yearFrom }}-{{ model.yearTo }}</td>
                    </tr>
                </table>
                <button (click)="toggleShowMore(vehicle[0])" 
                        [ngClass]="isMobile ? 'toggle-show-btnMobile' : 'toggle-show-btn'"
                        *ngIf="vehicle[1]?.length > 10" >
                    <div style="padding: 5px;">{{ showAllMap[vehicle[0]] ? 'Show Less' : 'Show More' }}</div>
                    <div style=" align-items: center; display: flex;">
                        <i class="material-icons" style="color: white; align-items: center;  display: flex;">
                            {{ showAllMap[vehicle[0]] ? 'expand_less' : 'expand_more' }}
                        </i>
                    </div>
                </button>
                </mat-tab>
            </div>
            
            </mat-tab-group>
        </div>
    </div>
  </div>
  <!-- END .page-wrapper -->
  <!-- Overlay -->
  <div class="popup-overlay" *ngIf="showPopup" (click)="closePopup()"></div>

  <!-- EMPTY STATE -->
  <div *ngIf="showEmptyState" class="empty-wrapper">

    <div class="empty-card">

      <!-- LEFT -->
      <div class="empty-left">
        <div class="placeholder-box">
          <img
            src="../../../../assets/images/cltch-kit-empty.jpeg"
            alt="Clutch Kit Empty"
            class="empty-image"
          />
        </div>
      </div>

      <!-- RIGHT -->
      <div class="empty-right">

        <h2>🔍  {{ kitTitle }} Not Available Instantly</h2>

        <p class="sub-text">
          We couldn't find a ready-to-dispatch  {{ kitTitle }} for this vehicle.
        </p>

        <div class="info-box">
          Don’t worry — we’ll help you find the right parts quickly.
        </div>

        <button class="btn-secondary" (click)="createClutchRequest()">
          📩 Create Request for {{ kitTitle }}
        </button>
      </div>

    </div>
  </div>
  <div class="popup" *ngIf="isPopupOpen">
    <div class="popup-content order-success-sec">
      <!-- <button mat-button (click)="closePopup()">Close</button> -->
      <img src="{{ successIcon }}" alt="Success Icon">
      <!-- <button class="close-popup" (click)="closePopup()">×</button> -->
      <mat-icon class="close-popup" (click)="closePopup()">close</mat-icon>
      <h3 *ngIf="addMoreItemsId">Request Updated!</h3>
      <h3 *ngIf="!addMoreItemsId">Request Created!</h3>
      <!-- <p class="order-label"><span class="order-id">Request ID  {{response.data.requestId}}</span></p> -->
      <p class="order-label">
        <span class="order-id">
          Request ID 
          {{ updatePopupData?.requestId }}
        </span>
      </p>
      <p class="date">
        <span>
          <!-- {{ updatePopupData?.requestCreatedAt || response?.data?.requestCreatedAt | date:'dd MMM yyyy, hh:mm a':'GMT+1060' }} -->
             {{ updatePopupData?.requestCreatedAt | date:'dd MMM yyyy, hh:mm a':'GMT+1060' }}
        </span>
      </p>
      <p class="thank-you">Let us deliver an awesome experience!</p>
      <!-- <button class="goto-order" (click)="closePopup()">Track My Request </button> -->
      <button class="goto-order" (click)="goToRequestDetails()">
        Track My Request
      </button>
    </div>
  </div>
    <!-- <button  class="floating-cta"  [ngClass]="{    'oem-floating-cta': selectedKitType === 'OEM',    'oes-floating-cta': selectedKitType === 'OES'  }"  *ngIf="showFloatingBtn" (click)="onAddToCart()">  ⚡ {{  avxSelectedAddonCount > 0  ? ('Order ' + kitTitle + ' Package')     : ('Order Complete ' + selectedKitType + ' ' + kitTitle) }}  </button> -->
     <button
        class="floating-cta"
        [ngClass]="{
          'oem-floating-cta': selectedKitType === 'OEM',
          'oes-floating-cta': selectedKitType === 'OES'
        }"
        *ngIf="showFloatingBtn"
        (click)="onFloatingCtaClick()">

        <ng-container *ngIf="!kitInCart">
          <mat-icon>shopping_cart</mat-icon>
          Add {{ selectedKitType }} {{ kitTitle }}
        </ng-container>

        <ng-container *ngIf="kitInCart">
          ₹{{ kitTotalAmount | number:'1.0-0' }} · View Cart
        </ng-container>

      </button>
  <!-- <div class="oess-fixed-btn-wrapper">
    <div class="oess-fixed-left">
      <div class="oess-selected-row">
        <span class="oess-green-dot"></span>
        <span class="oess-selected-text">
          {{ selectedKitType }} KIT SELECTED
        </span>
      </div>
      <div class="oess-info-box">
        <span class="oess-ordering-label">
          YOU ARE ORDERING
        </span>
        <div class="oess-kit-name">
          {{ selectedItem?.partName || 'Clutch Set + Release Bearing' }}
        </div>
        <div class="oess-warranty">
          ✔ Warranty Available
        </div>
      </div>
    </div>
    <div class="oess-fixed-right">
      <div class="oess-price-row">
        <div class="oess-price">
          ₹{{ pricingSummary?.totalSellingPrice || 0 }}
        </div>
        <div class="oess-save-pill"  *ngIf="selectedItem?.discount > 0 || pricingSummary?.savings > 0">
          {{ selectedItem?.discount || 0 }}% OFF •
          Save ₹{{ pricingSummary?.savings || 0 }}
        </div>
      </div>
      <button class="oess-order-btn"   (click)="onAddToCart()" >
        <div class="oess-btn-top">🟢 Order {{ selectedKitType }} Clutch Kit
        </div>
        <div class="oess-btn-sub">
          <span class="kit-name">
            {{ selectedItem?.partName || 'Clutch Kit' }}
          </span>

          <span class="kit-price">
           • ₹{{ pricingSummary?.totalSellingPrice || 0 }}
          </span>
        </div>
      </button>
      <div class="oess-fitment-text">
        ✔ Correct fitment for your vehicle
      </div>
    </div>
  </div> -->
</div>
